import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../components/feature/LanguageSwitcher';

export default function HomePage() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [activeFilter, setActiveFilter] = useState('all');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [expandedTech, setExpandedTech] = useState<string | null>(null);
  const [expandedCeylon, setExpandedCeylon] = useState(false);
  const [expandedKingCoconut, setExpandedKingCoconut] = useState(false);
  const [expandedGrowingMedia, setExpandedGrowingMedia] = useState(false);
  const [expandedCocoSubstrate, setExpandedCocoSubstrate] = useState(false);
  const [expandedGrowBags, setExpandedGrowBags] = useState(false);
  const [expandedGrowCube, setExpandedGrowCube] = useState(false);
  const [expandedGrowDisk, setExpandedGrowDisk] = useState(false);
  const [expandedCocoBrick, setExpandedCocoBrick] = useState(false);
  const [expandedGrowPole, setExpandedGrowPole] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d4msjc4u6ftm2u5dbiq0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setShowSuccessMessage(true);
        form.reset();
        setTimeout(() => setShowSuccessMessage(false), 5000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d4msjc4u6ftm2u5dbiqg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        form.reset();
        alert('Thank you for subscribing!');
      }
    } catch (error) {
      console.error('Newsletter submission error:', error);
    }
  };

  const toggleTechDetail = (techId: string) => {
    setExpandedTech(expandedTech === techId ? null : techId);
  };

  const toggleCeylonDetail = () => {
    setExpandedCeylon(!expandedCeylon);
  };

  const toggleKingCoconutDetail = () => {
    setExpandedKingCoconut(!expandedKingCoconut);
  };

  const toggleGrowingMediaDetail = () => {
    setExpandedGrowingMedia(!expandedGrowingMedia);
  };

  const toggleCocoSubstrateDetail = () => {
    setExpandedCocoSubstrate(!expandedCocoSubstrate);
  };

  const toggleGrowBagsDetail = () => {
    setExpandedGrowBags(!expandedGrowBags);
  };

  const toggleGrowCubeDetail = () => {
    setExpandedGrowCube(!expandedGrowCube);
  };

  const toggleGrowDiskDetail = () => {
    setExpandedGrowDisk(!expandedGrowDisk);
  };

  const toggleCocoBrickDetail = () => {
    setExpandedCocoBrick(!expandedCocoBrick);
  };

  const toggleGrowPoleDetail = () => {
    setExpandedGrowPole(!expandedGrowPole);
  };

  const scrollToProductDetail = (productId: number) => {
    let sectionId = '';
    if (productId === 1) sectionId = '#growbags-detail';
    else if (productId === 2) sectionId = '#growcube-detail';
    else if (productId === 3) sectionId = '#growdisk-detail';
    else if (productId === 4) sectionId = '#cocobrick-detail';
    else if (productId === 5) sectionId = '#growpole-detail';
    
    const section = document.querySelector(sectionId);
    if (section) {
      // 모바일에서는 개요 카드로 스크롤
      const overviewCard = section.querySelector('.bg-white.rounded-2xl.p-6, .bg-white.rounded-2xl.p-8');
      if (overviewCard && window.innerWidth < 1024) {
        overviewCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const products = [
    {
      id: 1,
      name: t('product.growbags.name'),
      category: 'hydroponics',
      description: t('product.growbags.description'),
      specs: ['pH 5.7-6.7', 'EC <0.5', 'Custom Mix'],
      image: 'https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/92fe16d0619a1f5da6963fa6ae6be4b1.jpeg',
      featured: false,
      badge: t('products.badge.bestseller')
    },
    {
      id: 2,
      name: t('product.growcube.name'),
      category: 'nursery',
      description: t('product.growcube.description'),
      specs: ['Organic', 'Biodegradable'],
      image: 'https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/2c9739bd8f350b2b2ee8acd096c0beea.jpeg',
      featured: false
    },
    {
      id: 3,
      name: t('product.growdisk.name'),
      category: 'nursery',
      description: t('product.growdisk.description'),
      specs: ['Gerbera Ready', 'Fast Drain'],
      image: 'https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/8a84d1517aa61c18056eff156e13c2f0.jpeg',
      featured: false
    },
    {
      id: 4,
      name: t('product.cocobrick.name'),
      category: 'gardening',
      description: t('product.cocobrick.description'),
      specs: ['Expands 60-70L'],
      image: 'https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/978a9955514fc1d742147eabb77d990e.jpeg',
      featured: false
    },
    {
      id: 5,
      name: t('product.growpole.name'),
      category: 'gardening',
      description: t('product.growpole.description'),
      specs: ['Monstera', 'Creepers'],
      image: 'https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/ddddf337e71aaeb6525beb1e3b66a113.jpeg',
      featured: false
    }
  ];

  const filteredProducts = activeFilter === 'all' 
    ? products 
    : products.filter(p => p.category === activeFilter);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/925302a5dec498201abba544d135ac66.jpeg" 
              alt="Golden Coco Logo"
              className="h-12 lg:h-16 w-auto object-contain"
              style={{ mixBlendMode: 'multiply' }}
            />
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8 xl:gap-10">
            <a href="#about" className={`text-sm xl:text-base font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-gray-700' : 'text-white'}`}>{t('nav.about')}</a>
            <a href="#technology" className={`text-sm xl:text-base font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-gray-700' : 'text-white'}`}>{t('nav.technology')}</a>
            <a href="#products" className={`text-sm xl:text-base font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-gray-700' : 'text-white'}`}>{t('nav.products')}</a>
            <a href="#contact" className={`text-sm xl:text-base font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-gray-700' : 'text-white'}`}>{t('nav.contact')}</a>
            <LanguageSwitcher />
          </div>

          {/* Mobile Menu Button */}
          <div className="flex lg:hidden items-center gap-4">
            <LanguageSwitcher />
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white shadow-lg">
            <div className="px-4 py-6 space-y-4">
              <a 
                href="#about" 
                onClick={() => setMobileMenuOpen(false)}
                className="block text-base font-medium text-gray-700 py-2 hover:text-teal-600 transition-colors cursor-pointer"
              >
                {t('nav.about')}
              </a>
              <a 
                href="#technology" 
                onClick={() => setMobileMenuOpen(false)}
                className="block text-base font-medium text-gray-700 py-2 hover:text-teal-600 transition-colors cursor-pointer"
              >
                {t('nav.technology')}
              </a>
              <a 
                href="#products" 
                onClick={() => setMobileMenuOpen(false)}
                className="block text-base font-medium text-gray-700 py-2 hover:text-teal-600 transition-colors cursor-pointer"
              >
                {t('nav.products')}
              </a>
              <a 
                href="#contact" 
                onClick={() => setMobileMenuOpen(false)}
                className="block text-base font-medium text-gray-700 py-2 hover:text-teal-600 transition-colors cursor-pointer"
              >
                {t('nav.contact')}
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/8dc2107ea24c706c33d4e62a4025603c.jpg" 
            alt="Coconut Plantation"
            className="w-full h-full object-cover object-top animate-slow-zoom"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40 animate-gradient-shift"></div>
          
          {/* Dynamic Light Effects */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            {/* Animated Light Beam 1 */}
            <div 
              className="absolute w-96 h-96 rounded-full opacity-30 blur-3xl animate-pulse"
              style={{
                background: 'radial-gradient(circle, rgba(253,184,19,0.4) 0%, transparent 70%)',
                top: '10%',
                left: '20%',
                animation: 'float 8s ease-in-out infinite'
              }}
            ></div>
            
            {/* Animated Light Beam 2 */}
            <div 
              className="absolute w-80 h-80 rounded-full opacity-20 blur-3xl animate-pulse"
              style={{
                background: 'radial-gradient(circle, rgba(253,184,19,0.3) 0%, transparent 70%)',
                top: '60%',
                right: '15%',
                animation: 'float 10s ease-in-out infinite 2s'
              }}
            ></div>
            
            {/* Animated Light Beam 3 */}
            <div 
              className="absolute w-72 h-72 rounded-full opacity-25 blur-3xl animate-pulse"
              style={{
                background: 'radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%)',
                bottom: '20%',
                left: '50%',
                animation: 'float 12s ease-in-out infinite 4s'
              }}
            ></div>
            
            {/* Moving Light Rays */}
            <div 
              className="absolute inset-0"
              style={{
                background: 'linear-gradient(45deg, transparent 30%, rgba(253,184,19,0.1) 50%, transparent 70%)',
                animation: 'slideLight 15s linear infinite'
              }}
            ></div>
            
            {/* Additional Floating Particles */}
            <div 
              className="absolute w-64 h-64 rounded-full opacity-20 blur-2xl"
              style={{
                background: 'radial-gradient(circle, rgba(253,184,19,0.3) 0%, transparent 70%)',
                top: '30%',
                right: '30%',
                animation: 'float-reverse 14s ease-in-out infinite 1s'
              }}
            ></div>
            
            <div 
              className="absolute w-56 h-56 rounded-full opacity-15 blur-2xl"
              style={{
                background: 'radial-gradient(circle, rgba(255,255,255,0.25) 0%, transparent 70%)',
                bottom: '40%',
                left: '15%',
                animation: 'float-reverse 16s ease-in-out infinite 3s'
              }}
            ></div>
          </div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full py-20">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-9xl font-black mb-6 sm:mb-8 lg:mb-12 tracking-wider leading-tight break-words" style={{ fontFamily: 'Montserrat, sans-serif', textShadow: '0 4px 20px rgba(0,0,0,0.3)', color: '#FDB813' }}>
            GOLDEN COCO
          </h1>
          
          <div className="w-full max-w-2xl mx-auto mb-6 sm:mb-8 lg:mb-12 px-4">
            <div className="h-0.5 lg:h-1 bg-white/30 mb-2 sm:mb-3 lg:mb-4"></div>
            <h2 className="text-base sm:text-xl lg:text-3xl font-semibold text-white mb-2 sm:mb-3 lg:mb-4 leading-relaxed break-words" style={{ fontFamily: 'Inter, sans-serif' }}>
              {t('hero.subtitle')}
            </h2>
            <div className="h-0.5 lg:h-1 bg-white/30"></div>
          </div>
          
          <p className="text-sm sm:text-base lg:text-lg text-white/90 mb-8 sm:mb-10 lg:mb-16 max-w-3xl mx-auto leading-relaxed px-4 break-words" style={{ fontFamily: 'Inter, sans-serif' }}>
            {t('hero.description')}
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 lg:gap-6 px-4">
            <a href="#products" className="w-full sm:w-auto px-5 sm:px-6 lg:px-8 py-3 lg:py-4 rounded-lg font-semibold text-sm lg:text-base transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer text-center" style={{ backgroundColor: '#FDB813', color: '#FFFFFF' }}>
              {t('hero.cta.explore')} <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a href="#contact" className="w-full sm:w-auto px-5 sm:px-6 lg:px-8 py-3 lg:py-4 rounded-lg font-semibold text-sm lg:text-base border-2 border-white text-white transition-all duration-300 hover:bg-white/10 whitespace-nowrap cursor-pointer text-center">
              {t('hero.cta.contact')}
            </a>
          </div>
        </div>
      </section>

      {/* Brand Story Section */}
      <section id="about" className="grid grid-cols-1 lg:grid-cols-2">
        {/* Left Column */}
        <div className="py-12 sm:py-16 lg:py-24 px-4 sm:px-6 lg:px-12 flex flex-col justify-center" style={{ backgroundColor: '#00ACC1' }}>
          <div className="max-w-xl mx-auto w-full">
            <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 mx-auto mb-4 sm:mb-6 lg:mb-8 rounded-full border-2 flex items-center justify-center" style={{ borderColor: '#FDB813' }}>
              <i className="ri-plant-line text-3xl sm:text-4xl lg:text-5xl" style={{ color: '#FDB813' }}></i>
            </div>
            
            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold mb-3 sm:mb-4 lg:mb-6 text-center text-white leading-tight break-words" style={{ fontFamily: 'Playfair Display, serif' }}>
              {t('story.title')}
            </h2>
            <div className="w-10 sm:w-12 lg:w-16 h-1 mx-auto mb-4 sm:mb-6 lg:mb-8" style={{ backgroundColor: '#FDB813' }}></div>
            
            <p className="text-sm sm:text-base lg:text-lg leading-relaxed mb-3 sm:mb-4 lg:mb-6 text-white/90 break-words" style={{ fontFamily: 'Inter, sans-serif', lineHeight: '1.8' }}>
              {t('story.paragraph1')}
            </p>
            
            <div className="w-10 sm:w-12 lg:w-16 h-0.5 my-3 sm:my-4 lg:my-6 mx-auto" style={{ backgroundColor: '#FDB813' }}></div>
            
            <p className="text-sm sm:text-base lg:text-lg leading-relaxed mb-4 sm:mb-6 lg:mb-8 text-white/90 break-words" style={{ fontFamily: 'Inter, sans-serif', lineHeight: '1.8' }}>
              {t('story.paragraph2')}
            </p>
            
            <p className="text-base sm:text-lg lg:text-xl italic font-medium text-center break-words" style={{ color: '#FDB813', fontFamily: 'Playfair Display, serif' }}>
              {t('story.mission')}
            </p>
          </div>
        </div>

        {/* Right Column */}
        <div className="relative py-12 sm:py-16 lg:py-24 px-4 sm:px-6 lg:px-12" style={{ backgroundColor: '#E0F7FA' }}>
          <div className="h-full flex flex-col justify-between">
            <div className="flex-1 mb-4 sm:mb-6 lg:mb-8">
              <img 
                src="https://readdy.ai/api/search-image?query=misty%20sri%20lankan%20hill%20country%20coconut%20plantation%20at%20sunrise%20with%20ancient%20palm%20trees%20and%20rolling%20hills%20atmospheric%20golden%20light%20heritage%20agricultural%20landscape%20professional%20photography&width=800&height=600&seq=7&orientation=landscape" 
                alt="Sri Lankan Plantation"
                className="w-full h-48 sm:h-64 lg:h-full object-cover rounded-2xl shadow-2xl object-top"
                style={{ maxHeight: '500px' }}
              />
            </div>
            
            <div className="grid grid-cols-3 gap-2 sm:gap-3 lg:gap-6">
              <div className="bg-white/80 backdrop-blur-sm p-2 sm:p-3 lg:p-6 rounded-lg border-l-4" style={{ borderColor: '#FDB813' }}>
                <div className="text-2xl sm:text-3xl lg:text-5xl font-bold mb-1 lg:mb-2 break-words" style={{ color: '#00ACC1', fontFamily: 'Montserrat, sans-serif' }}>1500+</div>
                <div className="text-xs lg:text-sm font-medium leading-tight break-words" style={{ color: '#3D2817' }}>{t('story.stat1')}</div>
              </div>
              <div className="bg-white/80 backdrop-blur-sm p-2 sm:p-3 lg:p-6 rounded-lg border-l-4" style={{ borderColor: '#FDB813' }}>
                <div className="text-2xl sm:text-3xl lg:text-5xl font-bold mb-1 lg:mb-2 break-words" style={{ color: '#00ACC1', fontFamily: 'Montserrat, sans-serif' }}>2000+</div>
                <div className="text-xs lg:text-sm font-medium leading-tight break-words" style={{ color: '#3D2817' }}>{t('story.stat2')}</div>
              </div>
              <div className="bg-white/80 backdrop-blur-sm p-2 sm:p-3 lg:p-6 rounded-lg border-l-4" style={{ borderColor: '#FDB813' }}>
                <div className="text-2xl sm:text-3xl lg:text-5xl font-bold mb-1 lg:mb-2 break-words" style={{ color: '#00ACC1', fontFamily: 'Montserrat, sans-serif' }}>500+</div>
                <div className="text-xs lg:text-sm font-medium leading-tight break-words" style={{ color: '#3D2817' }}>{t('story.stat3')}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Market Leadership Section */}
      <section className="py-16 sm:py-20 lg:py-32 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#F5F1E8' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-16 items-center">
            {/* Left Column - Text Content */}
            <div>
              <div className="inline-block px-3 lg:px-4 py-1.5 lg:py-2 rounded-full mb-3 sm:mb-4 lg:mb-6" style={{ backgroundColor: '#FDB813' }}>
                <span className="text-xs lg:text-sm font-bold text-white uppercase tracking-wider break-words">{t('market.badge')}</span>
              </div>
              
              <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold mb-3 sm:mb-4 lg:mb-6 leading-tight break-words" style={{ color: '#3D2817', fontFamily: 'Playfair Display, serif' }}>
                {t('market.title')}
              </h2>
              
              <div className="w-12 sm:w-16 lg:w-24 h-1 mb-4 sm:mb-6 lg:mb-8" style={{ backgroundColor: '#00ACC1' }}></div>
              
              <p className="text-sm sm:text-base lg:text-lg leading-relaxed mb-3 sm:mb-4 lg:mb-6 text-gray-700 break-words" style={{ lineHeight: '1.8' }}>
                {t('market.paragraph1')}
              </p>
              
              <p className="text-sm sm:text-base lg:text-lg leading-relaxed mb-4 sm:mb-6 lg:mb-8 text-gray-700 break-words" style={{ lineHeight: '1.8' }}>
                {t('market.paragraph2')}
              </p>

              <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:gap-6">
                <div className="bg-white p-3 sm:p-4 lg:p-6 rounded-xl shadow-md border-l-4" style={{ borderColor: '#FDB813' }}>
                  <div className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-1 lg:mb-2 break-words" style={{ color: '#00ACC1' }}>#4</div>
                  <div className="text-xs lg:text-sm font-medium text-gray-700 break-words">{t('market.stat.ranking')}</div>
                </div>
                <div className="bg-white p-3 sm:p-4 lg:p-6 rounded-xl shadow-md border-l-4" style={{ borderColor: '#FDB813' }}>
                  <div className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-1 lg:mb-2 break-words" style={{ color: '#00ACC1' }}>150+</div>
                  <div className="text-xs lg:text-sm font-medium text-gray-700 break-words">{t('market.stat.history')}</div>
                </div>
              </div>
            </div>

            {/* Right Column - Market Chart */}
            <div className="bg-white rounded-2xl p-4 sm:p-6 lg:p-8 shadow-2xl relative overflow-hidden">
              {/* Animated Background Gradient */}
              <div className="absolute inset-0 opacity-5 pointer-events-none">
                <div className="absolute inset-0 bg-gradient-to-br from-teal-400 via-cyan-400 to-blue-400 animate-gradient-flow"></div>
              </div>
              
              {/* Floating Particles */}
              <div className="absolute inset-0 pointer-events-none overflow-hidden">
                <div className="absolute w-2 h-2 bg-teal-400 rounded-full opacity-20 animate-float-particle-1"></div>
                <div className="absolute w-3 h-3 bg-cyan-400 rounded-full opacity-15 animate-float-particle-2"></div>
                <div className="absolute w-2 h-2 bg-blue-400 rounded-full opacity-20 animate-float-particle-3"></div>
                <div className="absolute w-1.5 h-1.5 bg-teal-300 rounded-full opacity-25 animate-float-particle-4"></div>
              </div>

              <div className="relative z-10 mb-4 lg:mb-6">
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 text-center break-words animate-fade-in-down" style={{ color: '#3D2817' }}>
                  {t('market.chart.title')}
                </h3>
                <div className="text-center animate-fade-in-up">
                  <span className="inline-block px-2 sm:px-3 lg:px-4 py-1 rounded-full text-xs font-bold break-words animate-pulse-glow" style={{ backgroundColor: '#FDB813', color: '#FFFFFF' }}>
                    {t('market.chart.confirmed')}
                  </span>
                </div>
                <p className="text-xs lg:text-sm text-center mt-2 text-gray-600 break-words animate-fade-in">
                  {t('market.chart.growth')}
                </p>
              </div>

              {/* Highlight Stats Grid */}
              <div className="relative z-10 grid grid-cols-2 gap-2 sm:gap-3 lg:gap-4 mb-4 lg:mb-6">
                <div className="bg-gradient-to-br from-green-50 to-teal-50 p-2 sm:p-3 lg:p-4 rounded-lg text-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg animate-slide-in-left">
                  <div className="text-lg sm:text-xl lg:text-2xl mb-1 animate-bounce-subtle">🥥</div>
                  <div className="text-base sm:text-lg lg:text-2xl font-bold break-words animate-count-up" style={{ color: '#00ACC1' }}>+167.8%</div>
                  <div className="text-xs text-gray-600 break-words">{t('market.chart.coconutCream')}</div>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-2 sm:p-3 lg:p-4 rounded-lg text-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg animate-slide-in-right" style={{ animationDelay: '0.1s' }}>
                  <div className="text-lg sm:text-xl lg:text-2xl mb-1 animate-bounce-subtle" style={{ animationDelay: '0.2s' }}>🥛</div>
                  <div className="text-base sm:text-lg lg:text-2xl font-bold break-words animate-count-up" style={{ color: '#00ACC1', animationDelay: '0.1s' }}>+105.6%</div>
                  <div className="text-xs text-gray-600 break-words">{t('market.chart.coconutMilk')}</div>
                </div>
                <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-2 sm:p-3 lg:p-4 rounded-lg text-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg animate-slide-in-left" style={{ animationDelay: '0.2s' }}>
                  <div className="text-lg sm:text-xl lg:text-2xl mb-1 animate-bounce-subtle" style={{ animationDelay: '0.4s' }}>💧</div>
                  <div className="text-base sm:text-lg lg:text-2xl font-bold break-words animate-count-up" style={{ color: '#00ACC1', animationDelay: '0.2s' }}>+92.6%</div>
                  <div className="text-xs text-gray-600 break-words">{t('market.chart.coconutOil')}</div>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-2 sm:p-3 lg:p-4 rounded-lg text-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg animate-slide-in-right" style={{ animationDelay: '0.3s' }}>
                  <div className="text-lg sm:text-xl lg:text-2xl mb-1 animate-bounce-subtle" style={{ animationDelay: '0.6s' }}>📈</div>
                  <div className="text-base sm:text-lg lg:text-2xl font-bold break-words animate-count-up" style={{ color: '#FDB813', animationDelay: '0.3s' }}>$133M</div>
                  <div className="text-xs text-gray-600 break-words">{t('market.chart.topExporter')}</div>
                </div>
              </div>
              
              <div className="relative z-10 space-y-2 sm:space-y-3 lg:space-y-4">
                {[
                  { country: t('market.chart.countries.usa'), value: 133, color: '#00ACC1' },
                  { country: t('market.chart.countries.germany'), value: 62, color: '#0891B2' },
                  { country: t('market.chart.countries.netherlands'), value: 57, color: '#06B6D4' },
                  { country: t('market.chart.countries.uk'), value: 48, color: '#FDB813' },
                  { country: t('market.chart.countries.china'), value: 53, color: '#FFA726' },
                  { country: t('market.chart.countries.canada'), value: 38, color: '#FF7043' },
                  { country: t('market.chart.countries.japan'), value: 35, color: '#EC407A' },
                  { country: t('market.chart.countries.australia'), value: 32, color: '#AB47BC' },
                  { country: t('market.chart.countries.india'), value: 29, color: '#7E57C2' },
                  { country: t('market.chart.countries.mexico'), value: 26, color: '#5C6BC0' }
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-2 lg:gap-4 animate-slide-in-left" style={{ animationDelay: `${0.4 + index * 0.05}s` }}>
                    <div className="w-16 sm:w-20 lg:w-32 text-xs lg:text-sm font-medium text-gray-700 text-right break-words">{item.country}</div>
                    <div className="flex-1 relative min-w-0">
                      <div 
                        className="h-5 sm:h-6 lg:h-8 rounded-r-lg transition-all duration-1000 hover:opacity-80 animate-bar-grow"
                        style={{ 
                          width: `${(item.value / 133) * 100}%`,
                          backgroundColor: item.color,
                          animationDelay: `${0.5 + index * 0.1}s`
                        }}
                      >
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-20 animate-shimmer-bar"></div>
                      </div>
                    </div>
                    <div className="w-10 sm:w-12 lg:w-16 text-xs lg:text-sm font-bold text-gray-700 break-words animate-fade-in" style={{ animationDelay: `${0.8 + index * 0.05}s` }}>${item.value}M</div>
                  </div>
                ))}
              </div>
              
              <div className="relative z-10 mt-4 lg:mt-6 pt-4 lg:pt-6 border-t border-gray-200 text-center animate-fade-in-up" style={{ animationDelay: '1.5s' }}>
                <p className="text-xs text-gray-500 italic break-words">{t('market.chart.value')}</p>
                <p className="text-xs text-gray-400 mt-1 break-words">{t('market.chart.source')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications & Quality Assurance Section - NEW */}
      <section className="py-32 px-8" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 rounded-full mb-6" style={{ backgroundColor: '#FDB813' }}>
              <span className="text-sm font-bold text-white uppercase tracking-wider">{t('certification.badge')}</span>
            </div>
            
            <h2 className="text-5xl font-bold mb-6 leading-tight" style={{ color: '#006064', fontFamily: 'Playfair Display, serif' }}>
              {t('certification.title')}
            </h2>
            
            <div className="w-24 h-1 mx-auto mb-8" style={{ backgroundColor: '#00ACC1' }}></div>
            
            <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
              {t('certification.description')}
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Certificate Summary */}
            <div className="relative">
              <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-8 shadow-2xl">
                <div className="bg-white rounded-2xl p-8 shadow-lg">
                  <div className="flex items-center gap-4 mb-8 pb-6 border-b-2 border-teal-200">
                    <div className="w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                      <i className="ri-verified-badge-fill text-3xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold mb-1" style={{ color: '#006064' }}>
                        {t('certification.phytosanitary.title')}
                      </h3>
                      <p className="text-sm text-gray-600">
                        {t('certification.phytosanitary.subtitle')}
                      </p>
                    </div>
                  </div>
                  
                  <div className="space-y-6">
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#E0F7FA' }}>
                        <i className="ri-shield-check-line text-xl" style={{ color: '#00ACC1' }}></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-800 mb-1">{t('certification.phytosanitary.standards.title')}</h4>
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {t('certification.phytosanitary.standards.desc')}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#E0F7FA' }}>
                        <i className="ri-bug-line text-xl" style={{ color: '#00ACC1' }}></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-800 mb-1">{t('certification.phytosanitary.fumigation.title')}</h4>
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {t('certification.phytosanitary.fumigation.desc')}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#E0F7FA' }}>
                        <i className="ri-global-line text-xl" style={{ color: '#00ACC1' }}></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-800 mb-1">{t('certification.phytosanitary.export.title')}</h4>
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {t('certification.phytosanitary.export.desc')}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#E0F7FA' }}>
                        <i className="ri-file-list-3-line text-xl" style={{ color: '#00ACC1' }}></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-800 mb-1">{t('certification.phytosanitary.documentation.title')}</h4>
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {t('certification.phytosanitary.documentation.desc')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="mt-6 text-center">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full" style={{ backgroundColor: '#00ACC1' }}>
                    <i className="ri-shield-check-line text-white text-xl"></i>
                    <span className="text-sm font-bold text-white">{t('certification.phytosanitary.certified')}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Certification Details */}
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4" style={{ borderColor: '#FDB813' }}>
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FFF8E1' }}>
                    <i className="ri-file-shield-2-line text-2xl" style={{ color: '#FDB813' }}></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold mb-2" style={{ color: '#006064' }}>{t('certification.fumigation.title')}</h3>
                    <p className="text-base text-gray-700 leading-relaxed">
                      {t('certification.fumigation.description')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4" style={{ borderColor: '#00ACC1' }}>
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#E0F7FA' }}>
                    <i className="ri-bug-line text-2xl" style={{ color: '#00ACC1' }}></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold mb-2" style={{ color: '#006064' }}>{t('certification.pestFree.title')}</h3>
                    <p className="text-base text-gray-700 leading-relaxed">
                      {t('certification.pestFree.description')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4" style={{ borderColor: '#FDB813' }}>
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FFF8E1' }}>
                    <i className="ri-global-line text-2xl" style={{ color: '#FDB813' }}></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold mb-2" style={{ color: '#006064' }}>{t('certification.international.title')}</h3>
                    <p className="text-base text-gray-700 leading-relaxed">
                      {t('certification.international.description')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl p-8 text-center">
                <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-8 mb-4">
                  <div className="text-center">
                    <div className="text-4xl font-bold text-white mb-2">100%</div>
                    <div className="text-sm text-teal-100 leading-relaxed">{t('certification.stats.safety')}</div>
                  </div>
                  <div className="hidden md:block w-px h-16 bg-white/30"></div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-white mb-2">ISO</div>
                    <div className="text-sm text-teal-100 leading-relaxed">{t('certification.stats.iso')}</div>
                  </div>
                  <div className="hidden md:block w-px h-16 bg-white/30"></div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-white mb-2">72{t('certification.stats.processing')}</div>
                    <div className="text-sm text-teal-100 leading-relaxed whitespace-nowrap">{t('certification.stats.processingLabel')}</div>
                  </div>
                </div>
                <p className="text-white/90 text-sm leading-relaxed px-4">
                  {t('certification.stats.description')}
                </p>
              </div>
            </div>
          </div>

          {/* Additional Quality Assurance Points */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-xl p-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: '#FDB813' }}>
                <i className="ri-microscope-line text-3xl text-white"></i>
              </div>
              <h4 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('certification.quality.lab')}</h4>
              <p className="text-sm text-gray-600">{t('certification.quality.labDesc')}</p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-xl p-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: '#00ACC1' }}>
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h4 className="font-bold mb-2" style={{ color: '#006064' }}>{t('certification.quality.assurance')}</h4>
              <p className="text-sm text-gray-600">{t('certification.quality.assuranceDesc')}</p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: '#059669' }}>
                <i className="ri-leaf-line text-3xl text-white"></i>
              </div>
              <h4 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('certification.quality.eco')}</h4>
              <p className="text-sm text-gray-600">{t('certification.quality.ecoDesc')}</p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: '#3B82F6' }}>
                <i className="ri-file-list-3-line text-3xl text-white"></i>
              </div>
              <h4 className="font-bold mb-2" style={{ color: '#1E40AF' }}>{t('certification.quality.documentation')}</h4>
              <p className="text-sm text-gray-600">{t('certification.quality.documentationDesc')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Ceylon Heritage Section */}
      <section className="py-32 px-8" style={{ backgroundColor: '#E8F4F8' }}>
        <div className="max-w-5xl mx-auto">
          <div className="inline-block px-4 py-2 rounded-full mb-6" style={{ backgroundColor: '#00ACC1' }}>
            <span className="text-sm font-bold text-white uppercase tracking-wider">{t('ceylon.badge')}</span>
          </div>
          
          <h2 className="text-5xl font-bold mb-8 leading-tight" style={{ color: '#006064', fontFamily: 'Playfair Display, serif' }}>
            {t('ceylon.title')}
          </h2>
          
          <div className="w-24 h-1 mb-10" style={{ backgroundColor: '#FDB813' }}></div>

          {/* Summary */}
          <div className="bg-white rounded-2xl p-10 shadow-xl">
            <p className="text-xl leading-relaxed text-gray-700 mb-6" style={{ lineHeight: '1.9' }}>
              {t('ceylon.summary')}
            </p>

            {/* Expandable Full Content */}
            {expandedCeylon && (
              <div className="mt-8 pt-8 border-t border-gray-200 space-y-6">
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('ceylon.content.intro')}
                </p>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('ceylon.content.origin')}
                </p>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('ceylon.content.history')}
                </p>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('ceylon.content.establishment')}
                </p>
                
                <div className="bg-gradient-to-r from-cyan-50 to-teal-50 p-6 rounded-xl border-l-4" style={{ borderColor: '#FDB813' }}>
                  <p className="text-base leading-relaxed font-medium" style={{ color: '#006064', lineHeight: '1.8' }}>
                    {t('ceylon.content.king')}
                  </p>
                </div>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('ceylon.content.colonial')}
                </p>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('ceylon.content.present')}
                </p>
              </div>
            )}

            {/* Toggle Button */}
            <button 
              onClick={toggleCeylonDetail}
              className="mt-8 w-full py-4 rounded-lg font-semibold text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              style={{ backgroundColor: '#00ACC1', color: '#FFFFFF' }}
            >
              {expandedCeylon ? t('ceylon.readLess') : t('ceylon.readMore')}
              <i className={`ri-arrow-${expandedCeylon ? 'up' : 'down'}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </section>

      {/* King Coconut Section - NEW */}
      <section className="py-32 px-8" style={{ backgroundColor: '#FFF8E1' }}>
        <div className="max-w-5xl mx-auto">
          <div className="inline-block px-4 py-2 rounded-full mb-6" style={{ backgroundColor: '#FDB813' }}>
            <span className="text-sm font-bold text-white uppercase tracking-wider">{t('kingCoconut.badge')}</span>
          </div>
          
          <h2 className="text-5xl font-bold mb-8 leading-tight" style={{ color: '#3D2817', fontFamily: 'Playfair Display, serif' }}>
            {t('kingCoconut.title')}
          </h2>
          
          <div className="w-24 h-1 mb-10" style={{ backgroundColor: '#00ACC1' }}></div>

          {/* Summary */}
          <div className="bg-white rounded-2xl p-10 shadow-xl">
            <p className="text-xl leading-relaxed text-gray-700 mb-6" style={{ lineHeight: '1.9' }}>
              {t('kingCoconut.summary')}
            </p>

            {/* Expandable Full Content */}
            {expandedKingCoconut && (
              <div className="mt-8 pt-8 border-t border-gray-200 space-y-6">
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('kingCoconut.content.intro')}
                </p>
                
                <div className="bg-gradient-to-r from-amber-50 to-yellow-50 p-6 rounded-xl border-l-4" style={{ borderColor: '#FDB813' }}>
                  <p className="text-base leading-relaxed font-medium" style={{ color: '#3D2817', lineHeight: '1.8' }}>
                    {t('kingCoconut.content.highlight')}
                  </p>
                </div>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('kingCoconut.content.characteristics')}
                </p>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('kingCoconut.content.cultivation')}
                </p>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('kingCoconut.content.quality')}
                </p>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('kingCoconut.content.conclusion')}
                </p>
              </div>
            )}

            {/* Toggle Button */}
            <button 
              onClick={toggleKingCoconutDetail}
              className="mt-8 w-full py-4 rounded-lg font-semibold text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              style={{ backgroundColor: '#FDB813', color: '#FFFFFF' }}
            >
              {expandedKingCoconut ? t('kingCoconut.readLess') : t('kingCoconut.readMore')}
              <i className={`ri-arrow-${expandedKingCoconut ? 'up' : 'down'}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </section>

      {/* Growing Media Alternatives Section - NEW */}
      <section className="py-32 px-8" style={{ backgroundColor: '#F5F5F5' }}>
        <div className="max-w-5xl mx-auto">
          <div className="inline-block px-4 py-2 rounded-full mb-6" style={{ backgroundColor: '#00ACC1' }}>
            <span className="text-sm font-bold text-white uppercase tracking-wider">{t('growingMedia.badge')}</span>
          </div>
          
          <h2 className="text-5xl font-bold mb-8 leading-tight" style={{ color: '#3D2817', fontFamily: 'Playfair Display, serif' }}>
            {t('growingMedia.title')}
          </h2>
          
          <div className="w-24 h-1 mb-10" style={{ backgroundColor: '#FDB813' }}></div>

          {/* Summary */}
          <div className="bg-white rounded-2xl p-10 shadow-xl">
            <p className="text-xl leading-relaxed text-gray-700 mb-6" style={{ lineHeight: '1.9' }}>
              {t('growingMedia.summary')}
            </p>

            {/* Expandable Full Content */}
            {expandedGrowingMedia && (
              <div className="mt-8 pt-8 border-t border-gray-200 space-y-6">
                <div className="space-y-8">
                  {/* Peat and Peat-Like Materials */}
                  <div>
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#00ACC1' }}>
                      {t('growingMedia.content.peat.title')}
                    </h4>
                    <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                      {t('growingMedia.content.peat.description')}
                    </p>
                  </div>

                  {/* Wood Residues */}
                  <div>
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#00ACC1' }}>
                      {t('growingMedia.content.wood.title')}
                    </h4>
                    <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                      {t('growingMedia.content.wood.description')}
                    </p>
                  </div>

                  {/* Bagasse */}
                  <div>
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#00ACC1' }}>
                      {t('growingMedia.content.bagasse.title')}
                    </h4>
                    <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                      {t('growingMedia.content.bagasse.description')}
                    </p>
                  </div>

                  {/* Rice Hulls */}
                  <div>
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#00ACC1' }}>
                      {t('growingMedia.content.rice.title')}
                    </h4>
                    <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                      {t('growingMedia.content.rice.description')}
                    </p>
                  </div>

                  {/* Sand */}
                  <div>
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#00ACC1' }}>
                      {t('growingMedia.content.sand.title')}
                    </h4>
                    <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                      {t('growingMedia.content.sand.description')}
                    </p>
                  </div>

                  {/* Perlite */}
                  <div>
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#00ACC1' }}>
                      {t('growingMedia.content.perlite.title')}
                    </h4>
                    <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                      {t('growingMedia.content.perlite.description')}
                    </p>
                  </div>

                  {/* Vermiculite */}
                  <div>
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#00ACC1' }}>
                      {t('growingMedia.content.vermiculite.title')}
                    </h4>
                    <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                      {t('growingMedia.content.vermiculite.description')}
                    </p>
                  </div>

                  {/* Calcined Clays */}
                  <div>
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#00ACC1' }}>
                      {t('growingMedia.content.calcined.title')}
                    </h4>
                    <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                      {t('growingMedia.content.calcined.description')}
                    </p>
                  </div>

                  {/* Expanded Polystyrene */}
                  <div>
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#00ACC1' }}>
                      {t('growingMedia.content.polystyrene.title')}
                    </h4>
                    <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                      {t('growingMedia.content.polystyrene.description')}
                    </p>
                  </div>

                  {/* Urea Formaldehydes */}
                  <div>
                    <h4 className="text-xl font-bold mb-3" style={{ color: '#00ACC1' }}>
                      {t('growingMedia.content.urea.title')}
                    </h4>
                    <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                      {t('growingMedia.content.urea.description')}
                    </p>
                  </div>

                  {/* Conclusion Highlight */}
                  <div className="bg-gradient-to-r from-teal-50 to-cyan-50 p-6 rounded-xl border-l-4" style={{ borderColor: '#FDB813' }}>
                    <p className="text-base leading-relaxed font-medium" style={{ color: '#006064', lineHeight: '1.8' }}>
                      {t('growingMedia.content.conclusion')}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Toggle Button */}
            <button 
              onClick={toggleGrowingMediaDetail}
              className="mt-8 w-full py-4 rounded-lg font-semibold text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              style={{ backgroundColor: '#00ACC1', color: '#FFFFFF' }}
            >
              {expandedGrowingMedia ? t('growingMedia.readLess') : t('growingMedia.readMore')}
              <i className={`ri-arrow-${expandedGrowingMedia ? 'up' : 'down'}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </section>

      {/* Coconut Substrate Importance Section - NEW */}
      <section className="py-32 px-8" style={{ backgroundColor: '#FFF3E0' }}>
        <div className="max-w-5xl mx-auto">
          <div className="inline-block px-4 py-2 rounded-full mb-6" style={{ backgroundColor: '#FDB813' }}>
            <span className="text-sm font-bold text-white uppercase tracking-wider">{t('cocoSubstrate.badge')}</span>
          </div>
          
          <h2 className="text-5xl font-bold mb-8 leading-tight" style={{ color: '#3D2817', fontFamily: 'Playfair Display, serif' }}>
            {t('cocoSubstrate.title')}
          </h2>
          
          <div className="w-24 h-1 mb-10" style={{ backgroundColor: '#00ACC1' }}></div>

          {/* Summary */}
          <div className="bg-white rounded-2xl p-10 shadow-xl">
            <p className="text-xl leading-relaxed text-gray-700 mb-6" style={{ lineHeight: '1.9' }}>
              {t('cocoSubstrate.summary')}
            </p>

            {/* Expandable Full Content */}
            {expandedCocoSubstrate && (
              <div className="mt-8 pt-8 border-t border-gray-200 space-y-6">
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('cocoSubstrate.content.intro')}
                </p>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('cocoSubstrate.content.processing')}
                </p>
                
                <div className="bg-gradient-to-r from-amber-50 to-orange-50 p-6 rounded-xl border-l-4" style={{ borderColor: '#FDB813' }}>
                  <p className="text-base leading-relaxed font-medium" style={{ color: '#3D2817', lineHeight: '1.8' }}>
                    {t('cocoSubstrate.content.structure')}
                  </p>
                </div>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('cocoSubstrate.content.properties')}
                </p>
                
                <p className="text-base leading-relaxed text-gray-700" style={{ lineHeight: '1.8' }}>
                  {t('cocoSubstrate.content.physical')}
                </p>
                
                <div className="bg-gradient-to-r from-teal-50 to-cyan-50 p-6 rounded-xl border-l-4" style={{ borderColor: '#00ACC1' }}>
                  <p className="text-base leading-relaxed font-medium" style={{ color: '#006064', lineHeight: '1.8' }}>
                    {t('cocoSubstrate.content.srilanka')}
                  </p>
                </div>
                
                <p className="text-xl italic font-semibold text-center my-6" style={{ color: '#FDB813', fontFamily: 'Playfair Display, serif' }}>
                  {t('cocoSubstrate.content.blessing')}
                </p>
                
                <div className="bg-gradient-to-r from-yellow-50 to-amber-50 p-6 rounded-xl border-l-4" style={{ borderColor: '#FDB813' }}>
                  <p className="text-base leading-relaxed font-medium" style={{ color: '#3D2817', lineHeight: '1.8' }}>
                    {t('cocoSubstrate.content.conclusion')}
                  </p>
                </div>
              </div>
            )}

            {/* Toggle Button */}
            <button 
              onClick={toggleCocoSubstrateDetail}
              className="mt-8 w-full py-4 rounded-lg font-semibold text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              style={{ backgroundColor: '#FDB813', color: '#FFFFFF' }}
            >
              {expandedCocoSubstrate ? t('cocoSubstrate.readLess') : t('cocoSubstrate.readMore')}
              <i className={`ri-arrow-${expandedCocoSubstrate ? 'up' : 'down'}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </section>

      {/* Technology Section */}
      <section id="technology" className="py-32 px-8" style={{ backgroundColor: '#B2EBF2' }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <div className="text-base font-bold uppercase tracking-widest mb-6" style={{ color: '#00838F' }}>{t('tech.subtitle')}</div>
            <h2 className="text-7xl font-bold mb-8 leading-tight" style={{ color: '#006064', fontFamily: 'Montserrat, sans-serif' }}>
              {t('tech.title.line1')}<br />{t('tech.title.line2')}
            </h2>
            <div className="w-20 h-1 mx-auto" style={{ backgroundColor: '#FDB813' }}></div>
          </div>

          {/* Technical Superiority Banner */}
          <div className="mb-20 rounded-3xl overflow-hidden shadow-2xl" style={{ background: 'linear-gradient(135deg, #0891B2 0%, #06B6D4 100%)' }}>
            <div className="px-12 py-16">
              <h3 className="text-4xl font-bold text-white mb-12 text-center leading-tight" style={{ fontFamily: 'Montserrat, sans-serif', color: '#FDB813' }}>
                {t('tech.superiority.title')}
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                {/* Water Retention */}
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                    <i className="ri-drop-line text-6xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold text-white mb-4">{t('tech.superiority.water.title')}</h4>
                  <p className="text-sm text-white/90 leading-relaxed">
                    {t('tech.superiority.water.description')}
                  </p>
                </div>

                {/* Air Holding (AFP) */}
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                    <i className="ri-windy-line text-6xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold text-white mb-4">{t('tech.superiority.air.title')}</h4>
                  <div className="text-3xl font-bold text-white mb-2" style={{ color: '#FDB813' }}>25% ~ 40%</div>
                  <p className="text-sm text-white/90">{t('tech.superiority.air.description')}</p>
                </div>

                {/* Chemical Balance */}
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                    <i className="ri-flask-line text-6xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold text-white mb-4">{t('tech.superiority.chemical.title')}</h4>
                  <div className="text-2xl font-bold text-white mb-2" style={{ color: '#FDB813' }}>pH: 5.7 - 6.7</div>
                  <div className="text-2xl font-bold text-white" style={{ color: '#FDB813' }}>EC: &lt; 0.5 mS/cm</div>
                </div>
              </div>

              <div className="mt-12 text-center">
                <p className="text-sm text-white/90 italic max-w-4xl mx-auto leading-relaxed">
                  {t('tech.superiority.quote')}
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {/* Perfect pH */}
            <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer">
              <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #FDB813 0%, #FFA726 100%)' }}>
                <i className="ri-flask-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-center leading-tight" style={{ color: '#006064' }}>{t('tech.ph.title')}</h3>
              <div className="text-5xl font-bold text-center mb-4" style={{ color: '#00ACC1' }}>5.7 - 6.7</div>
              <p className="text-base text-gray-600 text-center leading-relaxed">
                {t('tech.ph.description')}
              </p>
              <button 
                onClick={() => toggleTechDetail('ph')}
                className="block w-full text-center mt-6 font-medium transition-colors hover:underline cursor-pointer" 
                style={{ color: '#00838F' }}
              >
                {expandedTech === 'ph' ? t('tech.showLess') : t('tech.learnMore')} <i className={`ri-arrow-${expandedTech === 'ph' ? 'up' : 'right'}-line ml-1`}></i>
              </button>
              
              {expandedTech === 'ph' && (
                <div className="mt-6 pt-6 border-t border-gray-200 text-left space-y-4">
                  <h4 className="font-bold text-lg leading-tight" style={{ color: '#006064' }}>{t('tech.ph.detail.title')}</h4>
                  <p className="text-sm text-gray-700 leading-relaxed">{t('tech.ph.detail.p1')}</p>
                  <p className="text-sm text-gray-700 leading-relaxed">{t('tech.ph.detail.p2')}</p>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h5 className="font-semibold mb-2" style={{ color: '#00ACC1' }}>{t('tech.ph.detail.benefits')}</h5>
                    <ul className="text-sm text-gray-700 space-y-2">
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill mt-0.5" style={{ color: '#FDB813' }}></i>
                        <span>{t('tech.ph.detail.benefit1')}</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill mt-0.5" style={{ color: '#FDB813' }}></i>
                        <span>{t('tech.ph.detail.benefit2')}</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill mt-0.5" style={{ color: '#FDB813' }}></i>
                        <span>{t('tech.ph.detail.benefit3')}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {/* Low EC */}
            <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer">
              <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #FDB813 0%, #FFA726 100%)' }}>
                <i className="ri-water-flash-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-center leading-tight" style={{ color: '#006064' }}>{t('tech.ec.title')}</h3>
              <div className="text-5xl font-bold text-center mb-4" style={{ color: '#00ACC1' }}>&lt;0.5 mS/cm</div>
              <p className="text-base text-gray-600 text-center leading-relaxed">
                {t('tech.ec.description')}
              </p>
              <button 
                onClick={() => toggleTechDetail('ec')}
                className="block w-full text-center mt-6 font-medium transition-colors hover:underline cursor-pointer" 
                style={{ color: '#00838F' }}
              >
                {expandedTech === 'ec' ? t('tech.showLess') : t('tech.learnMore')} <i className={`ri-arrow-${expandedTech === 'ec' ? 'up' : 'right'}-line ml-1`}></i>
              </button>
              
              {expandedTech === 'ec' && (
                <div className="mt-6 pt-6 border-t border-gray-200 text-left space-y-4">
                  <h4 className="font-bold text-lg leading-tight" style={{ color: '#006064' }}>{t('tech.ec.detail.title')}</h4>
                  <p className="text-sm text-gray-700 leading-relaxed">{t('tech.ec.detail.p1')}</p>
                  <p className="text-sm text-gray-700 leading-relaxed">{t('tech.ec.detail.p2')}</p>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h5 className="font-semibold mb-2" style={{ color: '#00ACC1' }}>{t('tech.ec.detail.benefits')}</h5>
                    <ul className="text-sm text-gray-700 space-y-2">
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill mt-0.5" style={{ color: '#FDB813' }}></i>
                        <span>{t('tech.ec.detail.benefit1')}</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill mt-0.5" style={{ color: '#FDB813' }}></i>
                        <span>{t('tech.ec.detail.benefit2')}</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill mt-0.5" style={{ color: '#FDB813' }}></i>
                        <span>{t('tech.ec.detail.benefit3')}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {/* Durability */}
            <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer">
              <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #FDB813 0%, #FFA726 100%)' }}>
                <i className="ri-shield-check-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-center leading-tight" style={{ color: '#006064' }}>{t('tech.durability.title')}</h3>
              <div className="text-5xl font-bold text-center mb-4" style={{ color: '#00ACC1' }}>{t('tech.durability.value')}</div>
              <p className="text-base text-gray-600 text-center leading-relaxed">
                {t('tech.durability.description')}
              </p>
              <button 
                onClick={() => toggleTechDetail('durability')}
                className="block w-full text-center mt-6 font-medium transition-colors hover:underline cursor-pointer" 
                style={{ color: '#00838F' }}
              >
                {expandedTech === 'durability' ? t('tech.showLess') : t('tech.learnMore')} <i className={`ri-arrow-${expandedTech === 'durability' ? 'up' : 'right'}-line ml-1`}></i>
              </button>
              
              {expandedTech === 'durability' && (
                <div className="mt-6 pt-6 border-t border-gray-200 text-left space-y-4">
                  <h4 className="font-bold text-lg leading-tight" style={{ color: '#006064' }}>{t('tech.durability.detail.title')}</h4>
                  <p className="text-sm text-gray-700 leading-relaxed">{t('tech.durability.detail.p1')}</p>
                  <p className="text-sm text-gray-700 leading-relaxed">{t('tech.durability.detail.p2')}</p>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h5 className="font-semibold mb-2" style={{ color: '#00ACC1' }}>{t('tech.durability.detail.benefits')}</h5>
                    <ul className="text-sm text-gray-700 space-y-2">
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill mt-0.5" style={{ color: '#FDB813' }}></i>
                        <span>{t('tech.durability.detail.benefit1')}</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill mt-0.5" style={{ color: '#FDB813' }}></i>
                        <span>{t('tech.durability.detail.benefit2')}</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill mt-0.5" style={{ color: '#FDB813' }}></i>
                        <span>{t('tech.durability.detail.benefit3')}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#E0F7FA' }}>
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between mb-8 lg:mb-12 gap-6">
            <div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-2 leading-tight" style={{ color: '#006064', fontFamily: 'Montserrat, sans-serif' }}>{t('products.title')}</h2>
              <div className="w-16 lg:w-24 h-1" style={{ backgroundColor: '#FDB813' }}></div>
            </div>
            <div className="flex flex-wrap gap-2 lg:gap-3 w-full lg:w-auto">
              <button 
                onClick={() => setActiveFilter('all')}
                className={`px-4 lg:px-6 py-2 rounded-full text-xs lg:text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${activeFilter === 'all' ? 'text-white' : 'border-2 text-gray-700 hover:border-gray-400'}`}
                style={activeFilter === 'all' ? { backgroundColor: '#FDB813' } : { borderColor: '#FDB813' }}
              >
                {t('products.filter.all')}
              </button>
              <button 
                onClick={() => setActiveFilter('hydroponics')}
                className={`px-4 lg:px-6 py-2 rounded-full text-xs lg:text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${activeFilter === 'hydroponics' ? 'text-white' : 'border-2 text-gray-700 hover:border-gray-400'}`}
                style={activeFilter === 'hydroponics' ? { backgroundColor: '#FDB813' } : { borderColor: '#FDB813' }}
              >
                {t('products.filter.hydroponics')}
              </button>
              <button 
                onClick={() => setActiveFilter('nursery')}
                className={`px-4 lg:px-6 py-2 rounded-full text-xs lg:text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${activeFilter === 'nursery' ? 'text-white' : 'border-2 text-gray-700 hover:border-gray-400'}`}
                style={activeFilter === 'nursery' ? { backgroundColor: '#FDB813' } : { borderColor: '#FDB813' }}
              >
                {t('products.filter.nursery')}
              </button>
              <button 
                onClick={() => setActiveFilter('gardening')}
                className={`px-4 lg:px-6 py-2 rounded-full text-xs lg:text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${activeFilter === 'gardening' ? 'text-white' : 'border-2 text-gray-700 hover:border-gray-400'}`}
                style={activeFilter === 'gardening' ? { backgroundColor: '#FDB813' } : { borderColor: '#FDB813' }}
              >
                {t('products.filter.gardening')}
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-product-shop>
            {/* All Products - Equal Size */}
            {filteredProducts.map(product => (
              <div key={product.id} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] cursor-pointer">
                <div className="relative h-48 sm:h-56 lg:h-64">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover object-center" />
                  {product.badge && (
                    <div className="absolute top-4 left-4 px-3 lg:px-4 py-1.5 lg:py-2 rounded-full text-xs lg:text-sm font-semibold text-white" style={{ backgroundColor: product.featured ? '#00838F' : '#4CAF50' }}>
                      {product.badge}
                    </div>
                  )}
                </div>
                <div className="p-4 lg:p-6">
                  <h3 className="text-lg lg:text-xl font-bold mb-2 leading-tight" style={{ color: '#006064' }}>{product.name}</h3>
                  <p className="text-xs lg:text-sm text-gray-600 mb-3 lg:mb-4 leading-relaxed break-words">{product.description}</p>
                  <div className="flex gap-2 lg:gap-3 mb-3 lg:mb-4 flex-wrap">
                    {product.specs.map((spec, idx) => (
                      <span key={idx} className="px-2 lg:px-3 py-1 lg:py-1.5 rounded-lg text-xs font-medium break-words" style={{ backgroundColor: '#F5F1E8', color: '#3D2817' }}>
                        <i className="ri-checkbox-circle-line mr-1" style={{ color: '#D4AF37' }}></i>
                        {spec}
                      </span>
                    ))}
                  </div>
                  <button 
                    onClick={() => scrollToProductDetail(product.id)}
                    className="block w-full py-3 lg:py-3.5 rounded-lg text-center font-semibold text-xs lg:text-sm transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer"
                    style={{ backgroundColor: '#00ACC1', color: '#FFFFFF' }}
                  >
                    {t('products.card.cta.learnMore')} <i className="ri-arrow-right-line ml-1"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Premium Grow Bags Detailed Section - NEW */}
      <section id="growbags-detail" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#FFF8E1' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-start">
            {/* Left Column - Product Image */}
            <div className="lg:sticky lg:top-8 order-2 lg:order-1">
              <div className="bg-white rounded-3xl p-6 lg:p-8 shadow-2xl">
                <div className="relative h-64 sm:h-80 lg:h-96 mb-4 lg:mb-6 rounded-2xl overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/92fe16d0619a1f5da6963fa6ae6be4b1.jpeg" 
                    alt="Premium Grow Bags"
                    className="w-full h-full object-cover object-center"
                  />
                  <div className="absolute top-4 right-4 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold text-white" style={{ backgroundColor: '#FDB813' }}>
                    {t('products.badge.bestseller')}
                  </div>
                </div>
                
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 lg:mb-4 leading-tight" style={{ color: '#3D2817', fontFamily: 'Playfair Display, serif' }}>
                  {t('product.growbags.name')}
                </h3>
                
                <p className="text-base sm:text-lg text-gray-700 mb-4 lg:mb-6 leading-relaxed">
                  {t('product.growbags.detail.overview.description')}
                </p>

                <div className="grid grid-cols-3 gap-3 sm:gap-4 mb-4 lg:mb-6">
                  <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-3 sm:p-4 rounded-xl text-center">
                    <div className="text-xl sm:text-2xl font-bold mb-1" style={{ color: '#FDB813' }}>pH</div>
                    <div className="text-xs sm:text-sm text-gray-600">5.7-6.7</div>
                  </div>
                  <div className="bg-gradient-to-br from-yellow-50 to-orange-50 p-3 sm:p-4 rounded-xl text-center">
                    <div className="text-xl sm:text-2xl font-bold mb-1" style={{ color: '#FDB813' }}>EC</div>
                    <div className="text-xs sm:text-sm text-gray-600">&lt;0.5</div>
                  </div>
                  <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-3 sm:p-4 rounded-xl text-center">
                    <div className="text-xl sm:text-2xl font-bold mb-1" style={{ color: '#FDB813' }}>{t('product.growbags.detail.specs.mixRatioValue')}</div>
                    <div className="text-xs sm:text-sm text-gray-600">{t('product.growbags.detail.specs.mixRatio')}</div>
                  </div>
                </div>

                <button 
                  onClick={() => {
                    const section = document.querySelector('#contact');
                    section?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block w-full py-3 sm:py-4 rounded-lg text-center font-semibold text-sm sm:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer" 
                  style={{ backgroundColor: '#FDB813', color: '#FFFFFF' }}
                >
                  {t('products.card.cta.inquiry')} <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
            </div>

            {/* Right Column - Detailed Information */}
            <div className="space-y-6 lg:space-y-8 order-1 lg:order-2">
              {/* Overview Card */}
              <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg">
                <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-4 lg:mb-6" style={{ backgroundColor: '#FDB813' }}>
                  <span className="text-xs sm:text-sm font-bold text-white uppercase tracking-wider">{t('product.growbags.detail.overview.badge')}</span>
                </div>
                
                <h4 className="text-2xl sm:text-3xl font-bold mb-4 lg:mb-6 leading-tight" style={{ color: '#3D2817' }}>
                  {t('product.growbags.detail.overview.title')}
                </h4>

                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 lg:mb-6">
                  {t('product.growbags.detail.overview.description')}
                </p>

                {!expandedGrowBags && (
                  <button 
                    onClick={toggleGrowBagsDetail}
                    className="w-full py-3 sm:py-4 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#FDB813', color: '#FFFFFF' }}
                  >
                    {t('product.growbags.detail.learnMore')}
                    <i className="ri-arrow-down-line text-lg sm:text-xl"></i>
                  </button>
                )}
              </div>

              {/* Expandable Detailed Content */}
              {expandedGrowBags && (
                <>
                  {/* Key Features */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#3D2817' }}>
                      {t('product.growbags.detail.features.title')}
                    </h4>

                    <div className="space-y-4">
                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-plant-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.optimal')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.optimalDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-settings-3-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.custom')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.customDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-ruler-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.chipSize')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.chipSizeDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-leaf-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.organic')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.organicDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-recycle-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.eco')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.ecoDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-line-chart-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.growth')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.growthDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-drop-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.water')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.waterDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-flask-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.ph')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.phDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-water-flash-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.ec')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.ecDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-water-percent-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.drainage')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.drainageDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-home-gear-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.greenhouse')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.greenhouseDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-contrast-drop-2-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.drainageSlits')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.drainageSlitsDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-focus-3-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.plantingHoles')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.plantingHolesDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FFF8E1' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#FDB813' }}>
                          <i className="ri-drop-fill text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#3D2817' }}>{t('product.growbags.detail.features.dripHoles')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growbags.detail.features.dripHolesDesc')}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Technical Specifications */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#3D2817' }}>
                      {t('product.growbags.detail.specs.title')}
                    </h4>

                    <div className="space-y-4 mb-6">
                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#FFF8E1', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-3 font-semibold">{t('product.growbags.detail.specs.standardSizes')}</div>
                        <div className="grid grid-cols-2 gap-3 text-sm text-gray-700">
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill" style={{ color: '#FDB813' }}></i>
                            <span>100 x 15 x 10 cm</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill" style={{ color: '#FDB813' }}></i>
                            <span>100 x 15 x 12 cm</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill" style={{ color: '#FDB813' }}></i>
                            <span>100 x 18 x 12 cm</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill" style={{ color: '#FDB813' }}></i>
                            <span>100 x 20 x 12 cm</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill" style={{ color: '#FDB813' }}></i>
                            <span>100 x 18 x 14 cm</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill" style={{ color: '#FDB813' }}></i>
                            <span>100 x 20 x 14 cm</span>
                          </div>
                          <div className="flex items-center gap-2 col-span-2">
                            <i className="ri-checkbox-circle-fill" style={{ color: '#FDB813' }}></i>
                            <span>{t('product.growbags.detail.specs.customAvailable')}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#FFF8E1', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growbags.detail.specs.phRange')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#FDB813' }}>5.7 - 6.7</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#FFF8E1', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growbags.detail.specs.ec')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#FDB813' }}>&lt; 0.5 mS/cm</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#FFF8E1', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growbags.detail.specs.chipSize')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#FDB813' }}>7mm / 9mm / 10mm</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#FFF8E1', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growbags.detail.specs.mixRatio')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#FDB813' }}>{t('product.growbags.detail.specs.mixRatioValue')}</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#FFF8E1', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growbags.detail.specs.waterRetention')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#FDB813' }}>{t('product.growbags.detail.specs.waterRetentionValue')}</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#FFF8E1', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growbags.detail.specs.certification')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#FDB813' }}>{t('product.growbags.detail.specs.certificationValue')}</div>
                      </div>
                    </div>
                  </div>

                  {/* Applications */}
                  <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#3D2817' }}>
                      {t('product.growbags.detail.applications.title')}
                    </h4>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#FDB813' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growbags.detail.applications.tomato')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#FDB813' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growbags.detail.applications.pepper')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#FDB813' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growbags.detail.applications.strawberry')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#FDB813' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growbags.detail.applications.cucumber')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#FDB813' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growbags.detail.applications.eggplant')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#FDB813' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growbags.detail.applications.chili')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#FDB813' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growbags.detail.applications.berries')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#FDB813' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growbags.detail.applications.floriculture')}</span>
                      </div>
                    </div>
                  </div>

                  {/* Why Choose Golden Coco */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg border-2" style={{ borderColor: '#FDB813' }}>
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#3D2817' }}>
                      {t('product.growbags.detail.why.title')}
                    </h4>

                    <div className="space-y-4">
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#FDB813' }}>{t('product.growbags.detail.why.hydroponics.title')}</strong> {t('product.growbags.detail.why.hydroponics.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#FDB813' }}>{t('product.growbags.detail.why.premium.title')}</strong> {t('product.growbags.detail.why.premium.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#FDB813' }}>{t('product.growbags.detail.why.korean.title')}</strong> {t('product.growbags.detail.why.korean.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#FDB813' }}>{t('product.growbags.detail.why.proven.title')}</strong> {t('product.growbags.detail.why.proven.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#FDB813' }}>{t('product.growbags.detail.why.custom.title')}</strong> {t('product.growbags.detail.why.custom.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#FDB813' }}>{t('product.growbags.detail.why.sustainable.title')}</strong> {t('product.growbags.detail.why.sustainable.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#FDB813' }}>{t('product.growbags.detail.why.cost.title')}</strong> {t('product.growbags.detail.why.cost.desc')}
                      </p>
                    </div>

                    <div className="mt-8 p-6 rounded-xl" style={{ background: 'linear-gradient(135deg, #FDB813 0%, #FFA726 100%)' }}>
                      <p className="text-lg text-white text-center font-semibold leading-relaxed">
                        {t('product.growbags.detail.why.quote')}
                      </p>
                    </div>
                  </div>

                  {/* Collapse Button */}
                  <button 
                    onClick={toggleGrowBagsDetail}
                    className="w-full py-4 rounded-lg font-semibold text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#FDB813', color: '#FFFFFF' }}
                  >
                    {t('product.growbags.detail.showLess')}
                    <i className="ri-arrow-up-line text-xl"></i>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Grow Cube Detailed Section */}
      <section id="growcube-detail" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#F0F4F8' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-start">
            {/* Left Column - Product Image */}
            <div className="lg:sticky lg:top-8 order-2 lg:order-1">
              <div className="bg-white rounded-3xl p-6 lg:p-8 shadow-2xl">
                <div className="relative h-64 sm:h-80 lg:h-96 mb-4 lg:mb-6 rounded-2xl overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/2c9739bd8f350b2b2ee8acd096c0beea.jpeg" 
                    alt="Grow Cube"
                    className="w-full h-full object-cover object-center"
                  />
                  <div className="absolute top-4 right-4 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold text-white" style={{ backgroundColor: '#00ACC1' }}>
                    {t('products.card.badge.organic')}
                  </div>
                </div>
                
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 lg:mb-4 leading-tight" style={{ color: '#006064', fontFamily: 'Playfair Display, serif' }}>
                  {t('product.growcube.name')}
                </h3>
                
                <p className="text-base sm:text-lg text-gray-700 mb-4 lg:mb-6 leading-relaxed">
                  {t('product.growcube.detail.card.description')}
                </p>

                <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-4 lg:mb-6">
                  <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-3 sm:p-4 rounded-xl text-center">
                    <div className="text-2xl sm:text-3xl font-bold mb-1" style={{ color: '#00ACC1' }}>100%</div>
                    <div className="text-xs sm:text-sm text-gray-600">{t('product.growcube.detail.card.organic')}</div>
                  </div>
                  <div className="bg-gradient-to-br from-green-50 to-teal-50 p-3 sm:p-4 rounded-xl text-center">
                    <div className="text-2xl sm:text-3xl font-bold mb-1" style={{ color: '#00ACC1' }}>{t('product.growcube.detail.card.biodegradable')}</div>
                    <div className="text-xs sm:text-sm text-gray-600">{t('product.growcube.detail.card.eco')}</div>
                  </div>
                </div>

                <button 
                  onClick={() => {
                    const section = document.querySelector('#contact');
                    section?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block w-full py-3 sm:py-4 rounded-lg text-center font-semibold text-sm sm:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer" 
                  style={{ backgroundColor: '#FDB813', color: '#FFFFFF' }}
                >
                  {t('products.card.cta.inquiry')} <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
            </div>

            {/* Right Column - Detailed Information */}
            <div className="space-y-6 lg:space-y-8 order-1 lg:order-2">
              {/* Overview Card */}
              <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg">
                <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-4 lg:mb-6" style={{ backgroundColor: '#00ACC1' }}>
                  <span className="text-xs sm:text-sm font-bold text-white uppercase tracking-wider">{t('product.growcube.detail.overview.badge')}</span>
                </div>
                
                <h4 className="text-2xl sm:text-3xl font-bold mb-4 lg:mb-6 leading-tight" style={{ color: '#006064' }}>
                  {t('product.growcube.detail.overview.title')}
                </h4>

                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 lg:mb-6">
                  {t('product.growcube.detail.overview.description')}
                </p>

                {!expandedGrowCube && (
                  <button 
                    onClick={toggleGrowCubeDetail}
                    className="w-full py-3 sm:py-4 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#00ACC1', color: '#FFFFFF' }}
                  >
                    {t('product.growcube.detail.learnMore')}
                    <i className="ri-arrow-down-line text-lg sm:text-xl"></i>
                  </button>
                )}
              </div>

              {/* Expandable Detailed Content */}
              {expandedGrowCube && (
                <>
                  {/* Key Features */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#006064' }}>
                      {t('product.growcube.detail.features.title')}
                    </h4>

                    <div className="space-y-4">
                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E0F7FA' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#00ACC1' }}>
                          <i className="ri-seedling-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#006064' }}>{t('product.growcube.detail.features.optimal')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growcube.detail.features.optimalDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E0F7FA' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#00ACC1' }}>
                          <i className="ri-leaf-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#006064' }}>{t('product.growcube.detail.features.organic')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growcube.detail.features.organicDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E0F7FA' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#00ACC1' }}>
                          <i className="ri-recycle-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#006064' }}>{t('product.growcube.detail.features.biodegradable')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growcube.detail.features.biodegradableDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E0F7FA' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#00ACC1' }}>
                          <i className="ri-drop-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#006064' }}>{t('product.growcube.detail.features.water')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growcube.detail.features.waterDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E0F7FA' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#00ACC1' }}>
                          <i className="ri-plant-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#006064' }}>{t('product.growcube.detail.features.rootGrowth')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growcube.detail.features.rootGrowthDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E0F7FA' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#00ACC1' }}>
                          <i className="ri-home-gear-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#006064' }}>{t('product.growcube.detail.features.greenhouse')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growcube.detail.features.greenhouseDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E0F7FA' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#00ACC1' }}>
                          <i className="ri-water-flash-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#006064' }}>{t('product.growcube.detail.features.drainage')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growcube.detail.features.drainageDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E0F7FA' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#00ACC1' }}>
                          <i className="ri-stack-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#006064' }}>{t('product.growcube.detail.features.fastRoot')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growcube.detail.features.fastRootDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E0F7FA' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#00ACC1' }}>
                          <i className="ri-contrast-drop-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#006064' }}>{t('product.growcube.detail.features.dripHoles')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growcube.detail.features.dripHolesDesc')}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Technical Specifications */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#006064' }}>
                      {t('product.growcube.detail.specs.title')}
                    </h4>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0F4F8', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growcube.detail.specs.standardSize')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#00ACC1' }}>
                          7.5 x 7.5cm<br />
                          10 x 10cm<br />
                          15 x 15cm
                        </div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0F4F8', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growcube.detail.specs.phRange')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#00ACC1' }}>5.7 - 6.7</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0F4F8', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growcube.detail.specs.ec')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#00ACC1' }}>&lt; 0.5 mS/cm</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0F4F8', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growcube.detail.specs.waterRetention')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#00ACC1' }}>{t('product.growcube.detail.specs.waterRetentionValue')}</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0F4F8', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growcube.detail.specs.aeration')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#00ACC1' }}>{t('product.growcube.detail.specs.aerationValue')}</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0F4F8', borderColor: '#FDB813' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growcube.detail.specs.certification')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#00ACC1' }}>{t('product.growcube.detail.specs.certificationValue')}</div>
                      </div>
                    </div>
                  </div>

                  {/* Applications */}
                  <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#006064' }}>
                      {t('product.growcube.detail.applications.title')}
                    </h4>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#00ACC1' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growcube.detail.applications.nursery')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#00ACC1' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growcube.detail.applications.greenhouse')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#00ACC1' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growcube.detail.applications.hydroponics')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#00ACC1' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growcube.detail.applications.organic')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#00ACC1' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growcube.detail.applications.urban')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#00ACC1' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growcube.detail.applications.research')}</span>
                      </div>
                    </div>
                  </div>

                  {/* Why Choose Golden Coco */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg border-2" style={{ borderColor: '#FDB813' }}>
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#006064' }}>
                      {t('product.growcube.detail.why.title')}
                    </h4>

                    <div className="space-y-4">
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#00ACC1' }}>{t('product.growcube.detail.why.premium.title')}</strong> {t('product.growcube.detail.why.premium.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#00ACC1' }}>{t('product.growcube.detail.why.tradition.title')}</strong> {t('product.growcube.detail.why.tradition.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#00ACC1' }}>{t('product.growcube.detail.why.sustainable.title')}</strong> {t('product.growcube.detail.why.sustainable.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#00ACC1' }}>{t('product.growcube.detail.why.proven.title')}</strong> {t('product.growcube.detail.why.proven.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#00ACC1' }}>{t('product.growcube.detail.why.custom.title')}</strong> {t('product.growcube.detail.why.custom.desc')}
                      </p>
                    </div>

                    <div className="mt-8 p-6 rounded-xl" style={{ background: 'linear-gradient(135deg, #00ACC1 0%, #06B6D4 100%)' }}>
                      <p className="text-lg text-white text-center font-semibold leading-relaxed">
                        {t('product.growcube.detail.why.quote')}
                      </p>
                    </div>
                  </div>

                  {/* Collapse Button */}
                  <button 
                    onClick={toggleGrowCubeDetail}
                    className="w-full py-4 rounded-lg font-semibold text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#00ACC1', color: '#FFFFFF' }}
                  >
                    {t('product.growcube.detail.showLess')}
                    <i className="ri-arrow-up-line text-xl"></i>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Grow Disk Detailed Section */}
      <section id="growdisk-detail" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#E8F5E9' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-start">
            {/* Left Column - Product Image */}
            <div className="lg:sticky lg:top-8 order-2 lg:order-1">
              <div className="bg-white rounded-3xl p-6 lg:p-8 shadow-2xl">
                <div className="relative h-64 sm:h-80 lg:h-96 mb-4 lg:mb-6 rounded-2xl overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/8a84d1517aa61c18056eff156e13c2f0.jpeg" 
                    alt="Grow Disk"
                    className="w-full h-full object-cover object-center"
                  />
                  <div className="absolute top-4 right-4 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold text-white" style={{ backgroundColor: '#4CAF50' }}>
                    {t('products.card.badge.floriculture')}
                  </div>
                </div>
                
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 lg:mb-4 leading-tight" style={{ color: '#2E7D32', fontFamily: 'Playfair Display, serif' }}>
                  {t('product.growdisk.name')}
                </h3>
                
                <p className="text-base sm:text-lg text-gray-700 mb-4 lg:mb-6 leading-relaxed">
                  {t('products.card.description.growdisk')}
                </p>

                <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-4 lg:mb-6">
                  <div className="bg-gradient-to-br from-green-50 to-teal-50 p-3 sm:p-4 rounded-xl text-center">
                    <div className="text-2xl sm:text-3xl font-bold mb-1" style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.specs.drainageValue')}</div>
                    <div className="text-xs sm:text-sm text-gray-600">Fast Drain</div>
                  </div>
                  <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-3 sm:p-4 rounded-xl text-center">
                    <div className="text-2xl sm:text-3xl font-bold mb-1" style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.card.multipurpose')}</div>
                    <div className="text-xs sm:text-sm text-gray-600">{t('product.growdisk.detail.card.multipurpose')}</div>
                  </div>
                </div>

                <button 
                  onClick={() => {
                    const section = document.querySelector('#contact');
                    section?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block w-full py-3 sm:py-4 rounded-lg text-center font-semibold text-sm sm:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer" 
                  style={{ backgroundColor: '#4CAF50', color: '#FFFFFF' }}
                >
                  {t('products.card.cta.inquiry')} <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
            </div>

            {/* Right Column - Detailed Information */}
            <div className="space-y-6 lg:space-y-8 order-1 lg:order-2">
              {/* Overview Card */}
              <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg">
                <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-4 lg:mb-6" style={{ backgroundColor: '#4CAF50' }}>
                  <span className="text-xs sm:text-sm font-bold text-white uppercase tracking-wider">{t('product.growdisk.detail.overview.badge')}</span>
                </div>
                
                <h4 className="text-2xl sm:text-3xl font-bold mb-4 lg:mb-6 leading-tight" style={{ color: '#2E7D32' }}>
                  {t('product.growdisk.detail.overview.title')}
                </h4>

                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 lg:mb-6">
                  {t('product.growdisk.detail.overview.description')}
                </p>

                {!expandedGrowDisk && (
                  <button 
                    onClick={toggleGrowDiskDetail}
                    className="w-full py-3 sm:py-4 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#4CAF50', color: '#FFFFFF' }}
                  >
                    {t('product.growdisk.detail.learnMore')}
                    <i className="ri-arrow-down-line text-lg sm:text-xl"></i>
                  </button>
                )}
              </div>

              {/* Expandable Detailed Content */}
              {expandedGrowDisk && (
                <>
                  {/* Key Features */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#2E7D32' }}>
                      {t('product.growdisk.detail.features.title')}
                    </h4>

                    <div className="space-y-4">
                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-flower-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.optimal')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.optimalDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-plant-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.versatile')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.versatileDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-settings-3-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.custom')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.customDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-ruler-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.chipSize')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.chipSizeDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-leaf-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.organic')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.organicDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-recycle-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.eco')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.ecoDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-line-chart-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.growth')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.growthDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-drop-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.water')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.waterDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-windy-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.air')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.airDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-flask-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.ph')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.phDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-water-flash-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.ec')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.ecDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-water-percent-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.drainage')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.drainageDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-home-gear-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.greenhouse')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.greenhouseDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-contrast-drop-2-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.drainageSlits')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.drainageSlitsDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-focus-3-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.plantingHoles')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.plantingHolesDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#E8F5E9' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#4CAF50' }}>
                          <i className="ri-drop-fill text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#2E7D32' }}>{t('product.growdisk.detail.features.dripHoles')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growdisk.detail.features.dripHolesDesc')}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Technical Specifications */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#2E7D32' }}>
                      {t('product.growdisk.detail.specs.title')}
                    </h4>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F1F8E9', borderColor: '#4CAF50' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growdisk.detail.specs.standardSize')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#4CAF50' }}>
                          {t('product.growdisk.detail.specs.customSize')}
                        </div>
                        <div className="text-sm text-gray-600 mt-1">{t('product.growdisk.detail.specs.customSize')}</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F1F8E9', borderColor: '#4CAF50' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growdisk.detail.specs.phRange')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#4CAF50' }}>5.7 - 6.7</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F1F8E9', borderColor: '#4CAF50' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growdisk.detail.specs.ec')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#4CAF50' }}>&lt; 0.5 mS/cm</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F1F8E9', borderColor: '#4CAF50' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growdisk.detail.specs.drainage')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.specs.drainageValue')}</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F1F8E9', borderColor: '#4CAF50' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growdisk.detail.specs.aeration')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.specs.aerationValue')}</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F1F8E9', borderColor: '#4CAF50' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growdisk.detail.specs.application')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.specs.applicationValue')}</div>
                      </div>
                    </div>
                  </div>

                  {/* Applications */}
                  <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#2E7D32' }}>
                      {t('product.growdisk.detail.applications.title')}
                    </h4>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#4CAF50' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growdisk.detail.applications.floriculture')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#4CAF50' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growdisk.detail.applications.smallPlants')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#4CAF50' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growdisk.detail.applications.cannabis')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#4CAF50' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growdisk.detail.applications.vegetables')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#4CAF50' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growdisk.detail.applications.fruits')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#4CAF50' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growdisk.detail.applications.greenhouse')}</span>
                      </div>
                    </div>
                  </div>

                  {/* Why Choose Golden Coco */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg border-2" style={{ borderColor: '#4CAF50' }}>
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#2E7D32' }}>
                      {t('product.growdisk.detail.why.title')}
                    </h4>

                    <div className="space-y-4">
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.why.versatile.title')}</strong> {t('product.growdisk.detail.why.versatile.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.why.premium.title')}</strong> {t('product.growdisk.detail.why.premium.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.why.korean.title')}</strong> {t('product.growdisk.detail.why.korean.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.why.proven.title')}</strong> {t('product.growdisk.detail.why.proven.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.why.custom.title')}</strong> {t('product.growdisk.detail.why.custom.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#4CAF50' }}>{t('product.growdisk.detail.why.sustainable.title')}</strong> {t('product.growdisk.detail.why.sustainable.desc')}
                      </p>
                    </div>

                    <div className="mt-8 p-6 rounded-xl" style={{ background: 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)' }}>
                      <p className="text-lg text-white text-center font-semibold leading-relaxed">
                        {t('product.growdisk.detail.why.quote')}
                      </p>
                    </div>
                  </div>

                  {/* Collapse Button */}
                  <button 
                    onClick={toggleGrowDiskDetail}
                    className="w-full py-4 rounded-lg font-semibold text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#4CAF50', color: '#FFFFFF' }}
                  >
                    {t('product.growdisk.detail.showLess')}
                    <i className="ri-arrow-up-line text-xl"></i>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Grow Disk Detailed Product Section */}
      <section className="py-32 bg-gradient-to-br from-green-50 to-emerald-50">
        {/* ... existing Grow Disk code ... */}
      </section>

      {/* Compressed Coco Brick Detailed Product Section */}
      <section id="cocobrick-detail" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
            {/* Left Column - Sticky Product Card */}
            <div className="lg:sticky lg:top-32 h-fit order-2 lg:order-1">
              <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
                <div className="relative">
                  <img 
                    src="https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/978a9955514fc1d742147eabb77d990e.jpeg"
                    alt={t('product.cocobrick.name')}
                    className="w-full h-64 sm:h-80 lg:h-96 object-contain object-center p-6 lg:p-8"
                  />
                  <div className="absolute top-4 sm:top-6 right-4 sm:right-6 bg-gradient-to-r from-amber-600 to-orange-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full shadow-lg">
                    <span className="font-bold text-xs sm:text-sm uppercase tracking-wider">{t('products.card.badge.soilAmendment')}</span>
                  </div>
                </div>
                
                <div className="p-6 lg:p-8">
                  <h3 className="text-2xl sm:text-3xl font-bold mb-3 lg:mb-4" style={{ color: '#D97706' }}>
                    {t('product.cocobrick.name')}
                  </h3>
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-4 lg:mb-6">
                    {t('product.cocobrick.description')}
                  </p>
                  
                  <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-4 lg:mb-6">
                    <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-3 sm:p-4 text-center">
                      <div className="text-xl sm:text-2xl font-bold mb-1" style={{ color: '#D97706' }}>pH 5.7-6.7</div>
                      <div className="text-xs uppercase tracking-wide text-gray-600">{t('product.cocobrick.detail.card.ph')}</div>
                    </div>
                    <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-3 sm:p-4 text-center">
                      <div className="text-xl sm:text-2xl font-bold mb-1" style={{ color: '#D97706' }}>EC &lt;0.5</div>
                      <div className="text-xs uppercase tracking-wide text-gray-600">{t('product.cocobrick.detail.card.ec')}</div>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => {
                      const section = document.querySelector('#contact');
                      section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="w-full py-3 sm:py-4 rounded-xl font-bold text-sm sm:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer"
                    style={{ backgroundColor: '#D97706', color: '#FFFFFF' }}
                  >
                    {t('products.card.cta.inquiry')}
                  </button>
                </div>
              </div>
            </div>

            {/* Right Column - Detailed Content */}
            <div className="space-y-6 lg:space-y-8 order-1 lg:order-2">
              {/* Overview Card */}
              <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg">
                <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-4 lg:mb-6" style={{ backgroundColor: '#D97706' }}>
                  <span className="text-xs sm:text-sm font-bold text-white uppercase tracking-wider">{t('product.cocobrick.detail.overview.badge')}</span>
                </div>
                
                <h4 className="text-2xl sm:text-3xl font-bold mb-4 lg:mb-6 leading-tight" style={{ color: '#92400E' }}>
                  {t('product.cocobrick.detail.overview.title')}
                </h4>

                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 lg:mb-6">
                  {t('product.cocobrick.detail.overview.description')}
                </p>

                {!expandedCocoBrick && (
                  <button 
                    onClick={toggleCocoBrickDetail}
                    className="w-full py-3 sm:py-4 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#D97706', color: '#FFFFFF' }}
                  >
                    {t('product.cocobrick.detail.learnMore')}
                    <i className="ri-arrow-down-s-line text-lg sm:text-xl"></i>
                  </button>
                )}

                {expandedCocoBrick && (
                  <button 
                    onClick={toggleCocoBrickDetail}
                    className="w-full py-3 sm:py-4 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#92400E', color: '#FFFFFF' }}
                  >
                    {t('product.cocobrick.detail.showLess')}
                    <i className="ri-arrow-up-s-line text-lg sm:text-xl"></i>
                  </button>
                )}
              </div>

              {/* Expanded Content */}
              {expandedCocoBrick && (
                <div className="space-y-8 animate-fadeIn">
                  {/* Key Features */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h5 className="text-2xl font-bold mb-6" style={{ color: '#D97706' }}>
                      {t('product.cocobrick.detail.features.title')}
                    </h5>
                    
                    <div className="space-y-4">
                      {[
                        { key: 'soilMix' },
                        { key: 'versatile' },
                        { key: 'mixRatio' },
                        { key: 'chipSize' },
                        { key: 'organic' },
                        { key: 'eco' },
                        { key: 'disposal' },
                        { key: 'growth' },
                        { key: 'water' },
                        { key: 'air' },
                        { key: 'ph' },
                        { key: 'ec' },
                        { key: 'drainage' },
                        { key: 'greenhouse' },
                        { key: 'custom' }
                      ].map((feature, index) => (
                        <div key={index} className="flex items-start gap-4 p-4 rounded-xl bg-gradient-to-r from-amber-50 to-orange-50 hover:shadow-md transition-all duration-300">
                          <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                            <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#D97706' }}></i>
                          </div>
                          <p className="text-gray-700 leading-relaxed pt-1">{t(`product.cocobrick.detail.features.${feature.key}`)}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Technical Specifications */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h5 className="text-2xl font-bold mb-6" style={{ color: '#D97706' }}>
                      {t('product.cocobrick.detail.specs.title')}
                    </h5>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="p-6 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50">
                        <div className="flex items-start gap-3 mb-3">
                          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                            <i className="ri-ruler-line text-2xl" style={{ color: '#D97706' }}></i>
                          </div>
                          <div className="flex-1 min-w-0">
                            <h6 className="font-bold text-gray-800 mb-2">{t('product.cocobrick.detail.specs.standardSize')}</h6>
                            <p className="text-gray-700 text-sm leading-relaxed break-words">
                              {t('product.cocobrick.detail.specs.standardSizeDesc')}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="p-6 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50">
                        <div className="flex items-start gap-3 mb-3">
                          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                            <i className="ri-flask-line text-2xl" style={{ color: '#D97706' }}></i>
                          </div>
                          <div className="flex-1 min-w-0">
                            <h6 className="font-bold text-gray-800 mb-2">{t('product.cocobrick.detail.specs.phRange')}</h6>
                            <p className="text-gray-700 text-sm leading-relaxed break-words">
                              {t('product.cocobrick.detail.specs.phRangeDesc')}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="p-6 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50">
                        <div className="flex items-start gap-3 mb-3">
                          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                            <i className="ri-water-flash-line text-2xl" style={{ color: '#D97706' }}></i>
                          </div>
                          <div className="flex-1 min-w-0">
                            <h6 className="font-bold text-gray-800 mb-2">{t('product.cocobrick.detail.specs.ec')}</h6>
                            <p className="text-gray-700 text-sm leading-relaxed break-words">
                              {t('product.cocobrick.detail.specs.ecDesc')}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="p-6 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50">
                        <div className="flex items-start gap-3 mb-3">
                          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                            <i className="ri-settings-3-line text-2xl" style={{ color: '#D97706' }}></i>
                          </div>
                          <div className="flex-1 min-w-0">
                            <h6 className="font-bold text-gray-800 mb-2">{t('product.cocobrick.detail.specs.chipSize')}</h6>
                            <p className="text-gray-700 text-sm leading-relaxed break-words">
                              {t('product.cocobrick.detail.specs.chipSizeDesc')}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="p-6 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50">
                        <div className="flex items-start gap-3 mb-3">
                          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                            <i className="ri-contrast-drop-2-line text-2xl" style={{ color: '#D97706' }}></i>
                          </div>
                          <div className="flex-1 min-w-0">
                            <h6 className="font-bold text-gray-800 mb-2">{t('product.cocobrick.detail.specs.mixRatio')}</h6>
                            <p className="text-gray-700 text-sm leading-relaxed break-words">
                              {t('product.cocobrick.detail.specs.mixRatioDesc')}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="p-6 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50">
                        <div className="flex items-start gap-3 mb-3">
                          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                            <i className="ri-leaf-line text-2xl" style={{ color: '#D97706' }}></i>
                          </div>
                          <div className="flex-1 min-w-0">
                            <h6 className="font-bold text-gray-800 mb-2">{t('product.cocobrick.detail.specs.certification')}</h6>
                            <p className="text-gray-700 text-sm leading-relaxed break-words">
                              {t('product.cocobrick.detail.specs.certificationDesc')}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Applications */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h5 className="text-2xl font-bold mb-6" style={{ color: '#D97706' }}>
                      {t('product.cocobrick.detail.applications.title')}
                    </h5>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {[
                        { icon: 'ri-plant-line', key: 'soilImprovement' },
                        { icon: 'ri-seedling-line', key: 'nursery' },
                        { icon: 'ri-home-garden-line', key: 'homeGardening' },
                        { icon: 'ri-building-2-line', key: 'greenhouse' },
                        { icon: 'ri-landscape-line', key: 'landscaping' },
                        { icon: 'ri-flask-line', key: 'research' }
                      ].map((app, index) => (
                        <div key={index} className="p-6 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50 hover:shadow-md transition-all duration-300">
                          <div className="flex items-center gap-4">
                            <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                              <i className={`${app.icon} text-3xl`} style={{ color: '#D97706' }}></i>
                            </div>
                            <div>
                              <h6 className="font-bold text-gray-800 mb-1">{t(`product.cocobrick.detail.applications.${app.key}`)}</h6>
                              <p className="text-sm text-gray-600">{t(`product.cocobrick.detail.applications.${app.key}Desc`)}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Why Choose Golden Coco */}
                  <div className="bg-gradient-to-br from-amber-100 to-orange-100 rounded-2xl p-8 shadow-lg">
                    <h5 className="text-2xl font-bold mb-6" style={{ color: '#92400E' }}>
                      {t('product.cocobrick.detail.why.title')}
                    </h5>
                    
                    <div className="space-y-6">
                      <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6">
                        <h6 className="font-bold text-lg mb-3" style={{ color: '#D97706' }}>
                          <i className="ri-settings-3-line mr-2"></i>
                          {t('product.cocobrick.detail.why.custom.title')}
                        </h6>
                        <p className="text-gray-700 leading-relaxed">
                          {t('product.cocobrick.detail.why.custom.desc')}
                        </p>
                      </div>

                      <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6">
                        <h6 className="font-bold text-lg mb-3" style={{ color: '#D97706' }}>
                          <i className="ri-award-line mr-2"></i>
                          {t('product.cocobrick.detail.why.premium.title')}
                        </h6>
                        <p className="text-gray-700 leading-relaxed">
                          {t('product.cocobrick.detail.why.premium.desc')}
                        </p>
                      </div>

                      <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6">
                        <h6 className="font-bold text-lg mb-3" style={{ color: '#D97706' }}>
                          <i className="ri-leaf-line mr-2"></i>
                          {t('product.cocobrick.detail.why.organic.title')}
                        </h6>
                        <p className="text-gray-700 leading-relaxed">
                          {t('product.cocobrick.detail.why.organic.desc')}
                        </p>
                      </div>

                      <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6">
                        <h6 className="font-bold text-lg mb-3" style={{ color: '#D97706' }}>
                          <i className="ri-line-chart-line mr-2"></i>
                          {t('product.cocobrick.detail.why.proven.title')}
                        </h6>
                        <p className="text-gray-700 leading-relaxed">
                          {t('product.cocobrick.detail.why.proven.desc')}
                        </p>
                      </div>

                      <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6">
                        <h6 className="font-bold text-lg mb-3" style={{ color: '#D97706' }}>
                          <i className="ri-flask-line mr-2"></i>
                          {t('product.cocobrick.detail.why.korean.title')}
                        </h6>
                        <p className="text-gray-700 leading-relaxed">
                          {t('product.cocobrick.detail.why.korean.desc')}
                        </p>
                      </div>

                      <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6">
                        <h6 className="font-bold text-lg mb-3" style={{ color: '#D97706' }}>
                          <i className="ri-money-dollar-circle-line mr-2"></i>
                          {t('product.cocobrick.detail.why.cost.title')}
                        </h6>
                        <p className="text-gray-700 leading-relaxed">
                          {t('product.cocobrick.detail.why.cost.desc')}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* CTA Section */}
                  <div className="bg-gradient-to-r from-amber-600 to-orange-600 rounded-2xl p-10 text-center text-white shadow-xl">
                    <h5 className="text-3xl font-bold mb-4">
                      {t('product.cocobrick.detail.cta.title')}
                    </h5>
                    <p className="text-lg mb-6 text-amber-50">
                      {t('product.cocobrick.detail.cta.description')}
                    </p>
                    <button 
                      onClick={() => {
                        const section = document.querySelector('#contact');
                        section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }}
                      className="bg-white text-amber-700 px-8 py-4 rounded-full font-bold text-lg hover:bg-amber-50 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                    >
                      {t('product.cocobrick.detail.cta.button')}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Coco Grow Pole Detailed Section - NEW */}
      <section id="growpole-detail" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#F0FDF4' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-start">
            {/* Left Column - Product Image */}
            <div className="lg:sticky lg:top-8 order-2 lg:order-1">
              <div className="bg-white rounded-3xl p-6 lg:p-8 shadow-2xl">
                <div className="relative h-64 sm:h-80 lg:h-96 mb-4 lg:mb-6 rounded-2xl overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/ddddf337e71aaeb6525beb1e3b66a113.jpeg" 
                    alt="Coco Grow Pole"
                    className="w-full h-full object-cover object-center"
                  />
                  <div className="absolute top-4 right-4 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold text-white" style={{ backgroundColor: '#059669' }}>
                    {t('product.growpole.detail.overview.badge')}
                  </div>
                </div>
                
                <h3 className="text-xl sm:text-2xl font-bold mb-3 lg:mb-4" style={{ color: '#059669' }}>
                  {t('product.growpole.name')}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 mb-4 lg:mb-6">
                  {t('product.growpole.description')}
                </p>
                
                <div className="grid grid-cols-3 gap-3 sm:gap-4 mb-4 lg:mb-6">
                  <div className="text-center p-3 sm:p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                    <div className="text-xl sm:text-2xl font-bold mb-1" style={{ color: '#059669' }}>100%</div>
                    <div className="text-xs text-gray-600">{t('product.growpole.detail.card.organic')}</div>
                  </div>
                  <div className="text-center p-3 sm:p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                    <div className="text-xl sm:text-2xl font-bold mb-1" style={{ color: '#059669' }}>
                      <i className="ri-ruler-line"></i>
                    </div>
                    <div className="text-xs text-gray-600">{t('product.growpole.detail.card.custom')}</div>
                  </div>
                  <div className="text-center p-3 sm:p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                    <div className="text-xl sm:text-2xl font-bold mb-1" style={{ color: '#059669' }}>
                      <i className="ri-leaf-line"></i>
                    </div>
                    <div className="text-xs text-gray-600">{t('product.growpole.detail.card.eco')}</div>
                  </div>
                </div>
                
                <button 
                  onClick={() => {
                    const section = document.querySelector('#contact');
                    section?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full py-3 sm:py-4 rounded-xl text-white font-bold hover:opacity-90 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm sm:text-base"
                  style={{ backgroundColor: '#059669' }}
                >
                  {t('products.card.cta.inquiry')}
                </button>
              </div>
            </div>

            {/* Right Column - Detailed Information */}
            <div className="space-y-6 lg:space-y-8 order-1 lg:order-2">
              {/* Overview Card */}
              <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg">
                <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-4 lg:mb-6" style={{ backgroundColor: '#059669' }}>
                  <span className="text-xs sm:text-sm font-bold text-white uppercase tracking-wider">{t('product.growpole.detail.overview.badge')}</span>
                </div>
                
                <h4 className="text-2xl sm:text-3xl font-bold mb-4 lg:mb-6 leading-tight" style={{ color: '#065F46' }}>
                  {t('product.growpole.detail.overview.title')}
                </h4>

                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 lg:mb-6">
                  {t('product.growpole.detail.overview.description')}
                </p>

                {!expandedGrowPole && (
                  <button 
                    onClick={toggleGrowPoleDetail}
                    className="w-full py-3 sm:py-4 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#059669', color: '#FFFFFF' }}
                  >
                    {t('product.growpole.detail.learnMore')}
                    <i className="ri-arrow-down-line text-lg sm:text-xl"></i>
                  </button>
                )}
              </div>

              {/* Expandable Detailed Content */}
              {expandedGrowPole && (
                <>
                  {/* Key Features */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#065F46' }}>
                      {t('product.growpole.detail.features.title')}
                    </h4>

                    <div className="space-y-4">
                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-plant-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.optimal')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.optimalDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-settings-3-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.custom')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.customDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-ruler-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.chipSize')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.chipSizeDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-leaf-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.organic')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.organicDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-recycle-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.eco')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.ecoDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-line-chart-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.growth')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.growthDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-drop-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.water')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.waterDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-flask-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.ph')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.phDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-flashlight-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.ec')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.ecDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-water-flash-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.drainage')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.drainageDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-home-gear-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.greenhouse')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.greenhouseDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-scissors-cut-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.drainageSlits')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.drainageSlitsDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-seedling-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.plantingHoles')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.plantingHolesDesc')}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#F0FDF4' }}>
                        <div className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: '#059669' }}>
                          <i className="ri-contrast-drop-line text-xl text-white"></i>
                        </div>
                        <div>
                          <h5 className="font-bold mb-2" style={{ color: '#065F46' }}>{t('product.growpole.detail.features.dripHoles')}</h5>
                          <p className="text-sm text-gray-700 leading-relaxed">
                            {t('product.growpole.detail.features.dripHolesDesc')}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Technical Specifications */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#065F46' }}>
                      {t('product.growpole.detail.specs.title')}
                    </h4>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0FDF4', borderColor: '#059669' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growpole.detail.specs.size')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#059669' }}>{t('product.growpole.detail.specs.sizeValue')}</div>
                        <div className="text-sm text-gray-600 mt-1">{t('product.growpole.detail.specs.sizeDesc')}</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0FDF4', borderColor: '#059669' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growpole.detail.specs.phRange')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#059669' }}>5.7 - 6.7</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0FDF4', borderColor: '#059669' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growpole.detail.specs.ec')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#059669' }}>&lt; 0.5 mS/cm</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0FDF4', borderColor: '#059669' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growpole.detail.specs.material')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#059669' }}>{t('product.growpole.detail.specs.materialValue')}</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0FDF4', borderColor: '#059669' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growpole.detail.specs.waterRetention')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#059669' }}>{t('product.growpole.detail.specs.waterRetentionValue')}</div>
                      </div>

                      <div className="p-6 rounded-xl border-l-4" style={{ backgroundColor: '#F0FDF4', borderColor: '#059669' }}>
                        <div className="text-sm text-gray-600 mb-2">{t('product.growpole.detail.specs.certification')}</div>
                        <div className="text-2xl font-bold" style={{ color: '#059669' }}>{t('product.growpole.detail.specs.certificationValue')}</div>
                      </div>
                    </div>
                  </div>

                  {/* Applications */}
                  <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 shadow-lg">
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#065F46' }}>
                      {t('product.growpole.detail.applications.title')}
                    </h4>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#059669' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growpole.detail.applications.monstera')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#059669' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growpole.detail.applications.climbing')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#059669' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growpole.detail.applications.indoor')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#059669' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growpole.detail.applications.outdoor')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#059669' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growpole.detail.applications.nursery')}</span>
                      </div>
                      <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
                        <i className="ri-checkbox-circle-fill text-2xl" style={{ color: '#059669' }}></i>
                        <span className="font-medium text-gray-700">{t('product.growpole.detail.applications.farm')}</span>
                      </div>
                    </div>
                  </div>

                  {/* Why Choose Golden Coco */}
                  <div className="bg-white rounded-2xl p-8 shadow-lg border-2" style={{ borderColor: '#059669' }}>
                    <h4 className="text-2xl font-bold mb-6 leading-tight" style={{ color: '#065F46' }}>
                      {t('product.growpole.detail.why.title')}
                    </h4>

                    <div className="space-y-4">
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#059669' }}>{t('product.growpole.detail.why.natural.title')}</strong> {t('product.growpole.detail.why.natural.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#059669' }}>{t('product.growpole.detail.why.premium.title')}</strong> {t('product.growpole.detail.why.premium.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#059669' }}>{t('product.growpole.detail.why.custom.title')}</strong> {t('product.growpole.detail.why.custom.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#059669' }}>{t('product.growpole.detail.why.sustainable.title')}</strong> {t('product.growpole.detail.why.sustainable.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#059669' }}>{t('product.growpole.detail.why.health.title')}</strong> {t('product.growpole.detail.why.health.desc')}
                      </p>
                      <p className="text-base text-gray-700 leading-relaxed">
                        <strong style={{ color: '#059669' }}>{t('product.growpole.detail.why.aesthetic.title')}</strong> {t('product.growpole.detail.why.aesthetic.desc')}
                      </p>
                    </div>

                    <div className="mt-8 p-6 rounded-xl" style={{ background: 'linear-gradient(135deg, #059669 0%, #10B981 100%)' }}>
                      <p className="text-lg text-white text-center font-semibold leading-relaxed">
                        {t('product.growpole.detail.why.quote')}
                      </p>
                    </div>
                  </div>

                  {/* Collapse Button */}
                  <button 
                    onClick={toggleGrowPoleDetail}
                    className="w-full py-4 rounded-lg font-semibold text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#059669', color: '#FFFFFF' }}
                  >
                    {t('product.growpole.detail.showLess')}
                    <i className="ri-arrow-up-line text-xl"></i>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 lg:py-32 bg-gradient-to-br from-teal-900 to-cyan-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
            {/* Left Side */}
            <div className="relative py-12 lg:py-24 flex items-center justify-center overflow-hidden" style={{ backgroundColor: '#00838F' }}>
              <div className="absolute bottom-0 right-0 opacity-10">
                <i className="ri-plant-line" style={{ fontSize: '200px', color: '#FDB813' }}></i>
              </div>
              
              <div className="relative z-10 max-w-md w-full">
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-3 lg:mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {t('contact.title')}
                </h2>
                <p className="text-base lg:text-lg mb-8 lg:mb-12 text-white/90 leading-relaxed">
                  {t('contact.subtitle')}
                </p>

                <div className="space-y-6 lg:space-y-8">
                  <div className="flex items-center gap-3 lg:gap-4">
                    <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-2xl lg:text-3xl" style={{ color: '#FDB813' }}></i>
                    </div>
                    <div>
                      <div className="text-xs lg:text-sm text-gray-300 mb-1">{t('contact.email')}</div>
                      <a href="mailto:sales@insideglobal.co.kr" className="text-base lg:text-lg text-white hover:underline cursor-pointer break-all">
                        sales@insideglobal.co.kr
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 lg:gap-4">
                    <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-2xl lg:text-3xl" style={{ color: '#FDB813' }}></i>
                    </div>
                    <div>
                      <div className="text-xs lg:text-sm text-gray-300 mb-1">{t('contact.phone')}</div>
                      <a href="tel:062-229-1727" className="text-base lg:text-lg text-white hover:underline cursor-pointer">
                        062-229-1727
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 lg:gap-4">
                    <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center flex-shrink-0">
                      <i className="ri-global-line text-2xl lg:text-3xl" style={{ color: '#FDB813' }}></i>
                    </div>
                    <div>
                      <div className="text-xs lg:text-sm text-gray-300 mb-1">{t('contact.website')}</div>
                      <a href="http://www.insideglobal.co.kr" target="_blank" rel="noopener noreferrer" className="text-base lg:text-lg text-white hover:underline cursor-pointer break-all">
                        www.insideglobal.co.kr
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3 lg:gap-4">
                    <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center flex-shrink-0">
                      <i className="ri-building-line text-2xl lg:text-3xl" style={{ color: '#FDB813' }}></i>
                    </div>
                    <div>
                      <div className="text-xs lg:text-sm text-gray-300 mb-1">{t('contact.office.title')}</div>
                      <p className="text-sm lg:text-base text-white leading-relaxed">
                        {t('contact.office.address')}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3 lg:gap-4">
                    <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-2xl lg:text-3xl" style={{ color: '#FDB813' }}></i>
                    </div>
                    <div>
                      <div className="text-xs lg:text-sm text-gray-300 mb-1">{t('contact.factory.title')}</div>
                      <p className="text-sm lg:text-base text-white leading-relaxed">
                        {t('contact.factory.address')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div className="py-12 lg:py-24 flex items-center" style={{ backgroundColor: '#B2EBF2' }}>
              <div className="max-w-md w-full mx-auto px-4 sm:px-0">
                {showSuccessMessage && (
                  <div className="mb-6 p-4 rounded-lg" style={{ backgroundColor: '#FDB813', color: '#FFFFFF' }}>
                    <i className="ri-checkbox-circle-line mr-2"></i>
                    {t('contact.form.success')}
                  </div>
                )}
                
                <form className="space-y-6 lg:space-y-8" data-readdy-form id="contact-form" onSubmit={handleContactSubmit}>
                  <div className="relative">
                    <input 
                      type="text" 
                      name="name"
                      placeholder={t('contact.form.name')}
                      required
                      className="w-full bg-transparent border-b-2 py-3 lg:py-4 text-sm lg:text-base outline-none transition-colors focus:border-opacity-100"
                      style={{ borderColor: '#00ACC1', color: '#006064' }}
                    />
                  </div>

                  <div className="relative">
                    <input 
                      type="text" 
                      name="company"
                      placeholder={t('contact.form.company')}
                      required
                      className="w-full bg-transparent border-b-2 py-3 lg:py-4 text-sm lg:text-base outline-none transition-colors focus:border-opacity-100"
                      style={{ borderColor: '#00ACC1', color: '#006064' }}
                    />
                  </div>

                  <div className="relative">
                    <input 
                      type="email" 
                      name="email"
                      placeholder={t('contact.form.email')}
                      required
                      className="w-full bg-transparent border-b-2 py-3 lg:py-4 text-sm lg:text-base outline-none transition-colors focus:border-opacity-100"
                      style={{ borderColor: '#00ACC1', color: '#006064' }}
                    />
                  </div>

                  <div className="relative">
                    <input 
                      type="tel" 
                      name="phone"
                      placeholder={t('contact.form.phone')}
                      required
                      className="w-full bg-transparent border-b-2 py-3 lg:py-4 text-sm lg:text-base outline-none transition-colors focus:border-opacity-100"
                      style={{ borderColor: '#00ACC1', color: '#006064' }}
                    />
                  </div>

                  <div className="relative">
                    <textarea 
                      name="message"
                      placeholder={t('contact.form.message')}
                      rows={4}
                      maxLength={500}
                      required
                      className="w-full bg-transparent border-b-2 py-3 lg:py-4 text-sm lg:text-base outline-none transition-colors focus:border-opacity-100 resize-none"
                      style={{ borderColor: '#00ACC1', color: '#006064' }}
                    ></textarea>
                    <div className="text-xs text-gray-600 mt-1">{t('contact.form.maxChars')}</div>
                  </div>

                  <button 
                    type="submit"
                    className="w-full py-3 lg:py-4 rounded-lg font-semibold text-sm lg:text-base transition-all duration-300 hover:opacity-90 whitespace-nowrap cursor-pointer"
                    style={{ backgroundColor: '#FDB813', color: '#FFFFFF' }}
                  >
                    {t('contact.form.submit')}
                  </button>
                </form>

                <div className="mt-8 lg:mt-12 p-4 lg:p-6 bg-white rounded-xl shadow-md">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-building-line text-xl lg:text-2xl" style={{ color: '#00ACC1' }}></i>
                    </div>
                    <div>
                      <div className="font-bold text-sm lg:text-base leading-tight" style={{ color: '#006064' }}>{t('contact.company')}</div>
                      <div className="text-xs lg:text-sm text-gray-600">{t('contact.company.tagline')}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative py-12 lg:py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#006064' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-16 mb-12 lg:mb-16">
            {/* Brand Column */}
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-3 mb-4 lg:mb-6">
                <img 
                  src="https://static.readdy.ai/image/62accdbff4021f687ff0560f8cac3a8c/925302a5dec498201abba544d135ac66.jpeg" 
                  alt="Golden Coco Logo"
                  className="h-12 lg:h-14 w-auto object-contain bg-white rounded-lg p-2"
                />
              </div>
              <p className="text-xs lg:text-sm leading-relaxed mb-4 lg:mb-6 text-white/80" style={{ lineHeight: '1.6' }}>
                {t('footer.description')}
              </p>
              <div className="flex gap-3 lg:gap-4">
                <a href="#" className="w-10 h-10 rounded-full border-2 flex items-center justify-center transition-colors hover:bg-white/10 cursor-pointer" style={{ borderColor: '#FDB813' }}>
                  <i className="ri-linkedin-fill text-lg lg:text-xl" style={{ color: '#FDB813' }}></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border-2 flex items-center justify-center transition-colors hover:bg-white/10 cursor-pointer" style={{ borderColor: '#FDB813' }}>
                  <i className="ri-instagram-line text-lg lg:text-xl" style={{ color: '#FDB813' }}></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border-2 flex items-center justify-center transition-colors hover:bg-white/10 cursor-pointer" style={{ borderColor: '#FDB813' }}>
                  <i className="ri-youtube-line text-lg lg:text-xl" style={{ color: '#FDB813' }}></i>
                </a>
              </div>
            </div>

            {/* Newsletter Column */}
            <div>
              <div className="text-xs font-bold uppercase tracking-widest mb-4 lg:mb-6" style={{ color: '#FDB813' }}>{t('footer.newsletter.title')}</div>
              <form className="mb-3 lg:mb-4" data-readdy-form id="newsletter-form" onSubmit={handleNewsletterSubmit}>
                <div className="relative">
                  <input 
                    type="email" 
                    name="email"
                    placeholder={t('footer.newsletter.placeholder')}
                    required
                    className="w-full bg-transparent border-b py-2 lg:py-3 pr-10 text-xs lg:text-sm outline-none text-white placeholder-gray-300"
                    style={{ borderColor: 'rgba(255,255,255,0.3)' }}
                  />
                  <button type="submit" className="absolute right-0 top-1/2 -translate-y-1/2 cursor-pointer">
                    <i className="ri-arrow-right-line text-lg lg:text-xl" style={{ color: '#FDB813' }}></i>
                  </button>
                </div>
              </form>
              <a href="#" className="text-xs text-gray-300 hover:underline cursor-pointer">{t('footer.privacy')}</a>
            </div>

            {/* Products Column */}
            <div>
              <div className="text-xs font-bold uppercase tracking-widest mb-4 lg:mb-6" style={{ color: '#FDB813' }}>{t('footer.products.title')}</div>
              <div className="space-y-3 lg:space-y-4">
                <a href="#products" className="block text-sm lg:text-base text-white hover:underline transition-colors cursor-pointer" style={{ lineHeight: '2' }}>{t('product.growbags.name')}</a>
                <a href="#products" className="block text-sm lg:text-base text-white hover:underline transition-colors cursor-pointer" style={{ lineHeight: '2' }}>{t('product.growcube.name')}</a>
                <a href="#products" className="block text-sm lg:text-base text-white hover:underline transition-colors cursor-pointer" style={{ lineHeight: '2' }}>{t('product.growdisk.name')}</a>
                <a href="#products" className="block text-sm lg:text-base text-white hover:underline transition-colors cursor-pointer" style={{ lineHeight: '2' }}>{t('product.cocobrick.name')}</a>
                <a href="#products" className="block text-sm lg:text-base text-white hover:underline transition-colors cursor-pointer" style={{ lineHeight: '2' }}>{t('product.growpole.name')}</a>
              </div>
            </div>

            {/* Resources Column */}
            <div>
              <div className="text-xs font-bold uppercase tracking-widest mb-4 lg:mb-6" style={{ color: '#FDB813' }}>{t('footer.resources.title')}</div>
              <div className="space-y-3 lg:space-y-4">
                <a href="#about" className="block text-sm lg:text-base text-white hover:underline transition-colors cursor-pointer" style={{ lineHeight: '2' }}>{t('footer.resources.about')}</a>
                <a href="#technology" className="block text-sm lg:text-base text-white hover:underline transition-colors cursor-pointer" style={{ lineHeight: '2' }}>{t('footer.resources.technology')}</a>
                <a href="#contact" className="block text-sm lg:text-base text-white hover:underline transition-colors cursor-pointer" style={{ lineHeight: '2' }}>{t('footer.resources.contact')}</a>
                <a href="#" className="block text-sm lg:text-base text-white hover:underline transition-colors cursor-pointer" style={{ lineHeight: '2' }}>{t('footer.resources.documentation')}</a>
                <a href="#" className="block text-sm lg:text-base text-white hover:underline transition-colors cursor-pointer" style={{ lineHeight: '2' }}>{t('footer.resources.support')}</a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-6 lg:pt-8 border-t" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-xs lg:text-sm text-gray-300 text-center md:text-left">
                {t('footer.copyright')}
              </p>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-xs lg:text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                {t('footer.poweredBy')}
              </a>
            </div>
          </div>
        </div>

        {/* Large Background Text */}
        <div className="absolute bottom-4 lg:bottom-8 left-0 right-0 pointer-events-none overflow-hidden">
          <div className="text-center text-5xl sm:text-7xl lg:text-9xl font-bold opacity-5" style={{ color: '#FDB813', fontFamily: 'Montserrat, sans-serif', WebkitTextStroke: '1px #FDB813', WebkitTextFillColor: 'transparent' }}>
            GOLDEN COCO
          </div>
        </div>
      </footer>
    </div>
  );
}
